import { k, b, G, a, l, F, y, fa as fa$1, da as da$1, ha, n as n$1, w, p, q as q$1, o, x, E, e, h, f as f$1, ea, $, aa, ca, j, R, O, r, M, Z, s, u as u$1, i, A, K, z } from './chunk-6U7NJMP6.js';
import { n, a as a$1, u, s as s$1, D, B, o as o$1, t, b as b$1, g, p as p$1 } from './chunk-DK6SHBNG.js';
import { f as f$2, e as e$1 } from './chunk-2GKQDRWV.js';
import { f, j as j$1, e as e$2, h as h$1, d, g as g$1 } from './chunk-XMRQGGIB.js';
import { c } from './chunk-6F4N3CZZ.js';
import Ze, { css, keyframes, createGlobalStyle, useTheme, ThemeProvider } from 'styled-components';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { rgba, parseToRgb } from 'polished';
import * as Y from 'react';
import Y__default, { forwardRef, memo, useMemo, useRef, useState, useCallback, useImperativeHandle, useEffect, createElement, useLayoutEffect } from 'react';
import { animated, useSpring, useTransition } from 'react-spring';
import { defineMessages, useLocales, commonMessages, LocaleRoot, gflMessages } from '@sevenrooms/locales';
import he from 'lodash';
import { Breadcrumbs } from '@sevenrooms/react-components/components/Breadcrumbs';
import { useThrottledCallback } from 'use-debounce';
import lo from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import { Carousel, useCarousel } from 'nuka-carousel';
import { ExperienceBySevenRooms } from '@sevenrooms/react-components/components/ExperienceBySevenRooms';
import { Link, useNavigation, useSurfaceScope, useLocation, matchPath } from '@sevenrooms/navigation';
import Bl from 'react-focus-lock';
import On from 'react-merge-refs';
import { TouchScrollable } from 'react-scrolllock';
import { ToastContainer, cssTransition, toast, Slide, Bounce, Zoom, Flip } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ud from 'css-time';
import Sd from 'react-keyboard-event-handler';
import { Transition } from 'react-transition-group';
import { useCombobox } from 'downshift';
import jd from 'use-resize-observer';
import { useFormState } from '@sevenrooms/form';
import ko from 'moment/moment';
import { DayPickerSingleDateController } from 'react-dates';
import 'react-dates/initialize';
import '@fontsource/roboto';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import { Normalize } from 'styled-normalize';
import { ThemeProvider as ThemeProvider$1, vmsTheme, gxTheme } from '@sevenrooms/react-components/components/ThemeProvider';
import * as Ii from 'react-dom';
import Ep from 'constate';
import { useTable, useSortBy, useExpanded, usePagination, useRowSelect } from 'react-table';
import * as fe from 'react-tabs';
import { SevenRoomsIcon } from '@sevenrooms/react-components/components/SevenRoomsIcon';
import { SevenRoomsProgress } from '@sevenrooms/react-components/components/SevenRoomsProgress';
import { parsePhoneNumber } from 'react-phone-number-input';
import { readIFrameMessage } from '@sevenrooms/connect-iframe';
import { Avatar } from '@sevenrooms/react-components/components/Avatar';
import { IconButton } from '@sevenrooms/react-components/components/IconButton';
import { Menu } from '@sevenrooms/react-components/components/Menu';
import { MenuItem } from '@sevenrooms/react-components/components/MenuItem';

function Er({firstName:e,lastName:t,size:o,fontSize:r,image:n,textStyle:i}){let a=e?.charAt(0)??"",s=t?.charAt(0)??"",p=a+s,d=o||"24px";return jsx(La,{width:d,height:d,image:n,fontSize:r,textStyle:i,children:n?null:p})}var La=Ze(k)`
  align-items: center;
  background-color: ${e=>e.theme.colors.mutedBackground};
  border-radius: 50%;
  color: ${e=>e.theme.colors.mutedFont};
  ${e=>e.textStyle&&`font: ${e.theme.textStyles[e.textStyle]};`}
  font-size: ${e=>e.fontSize?e.theme.fontSizes[e.fontSize]:e.theme.fontSizes.s};
  justify-content: center;
  text-transform: uppercase;
  ${e=>e.image&&css`
      background-size: cover;
      background-image: url(${e.image});
    `}
`;function zr(e){let t=useTheme(),o=Y.useMemo(()=>({visible:rgba({...parseToRgb(t.colors.backdrop),alpha:.3}),invisible:rgba({...parseToRgb(t.colors.backdrop),alpha:0})}),[t.colors.backdrop]),r=useSpring({backgroundColor:e.isActive?o.visible:o.invisible,pointerEvents:e.isActive?"all":"none",config:{duration:150}});return jsx(za,{...e,style:r,"data-test":"ui-kit-backdrop",children:e.children})}var za=Ze(animated.div).withConfig({shouldForwardProp:e=>e!=="isActive"})`
  will-change: background-color, pointer-events;
  position: fixed;
  z-index: ${e=>e.theme.zIndex.modal};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;function gu({title:e$2,description:t,to:o,isExternal:r,icon:n,...i}){let a$1=jsxs(Aa,{borderRadius:"s",borderColor:"dividerLines",borderWidth:"s",backgroundColor:"primaryBackground",alignItems:"center",justifyContent:"center",flexWrap:"wrap",...i,children:[n&&jsx(Oa,{pr:"m",flexDirection:"column",flex:"0 0",children:n}),jsxs(k,{pr:"m",flexDirection:"column",flex:"10 1 250px",children:[jsx(a,{children:jsx(e,{fontWeight:"bold",children:e$2})}),t&&jsx(j,{fontSize:"s",children:t})]}),o&&jsx(_a,{pl:"m",flexDirection:"column",flex:"0 0",children:jsx(e$1,{name:"VMSWeb-chevron-right",size:"lg"})})]});return o?jsx(R,{to:o,isExternal:r,"data-test":"action-link",children:a$1}):a$1}var Aa=Ze(k)`
  ${e=>"p"in e?css`
          padding: ${b(e,e.p)};
        `:css`
          padding-top: ${b(e,e.pt)};
          padding-right: ${b(e,e.pr)};
          padding-bottom: ${b(e,e.pb)};
          padding-left: ${b(e,e.pl)};
        `}
`,Oa=Ze(k)`
  ${e=>css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1.2em;
        height: 1.2em;
        border-radius: 50%;
        background-color: ${e.theme.colors.highlight};
        border: 1px solid ${e.theme.colors.brandColor};
        padding: 2px;
    `}
`,_a=Ze(k)`
  ${e=>css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 1.2em;
        height: 1.2em;
        border-radius: 50%;
        background-color: ${e.theme.colors.iconHover};
    `}
`;var Ar='data:image/svg+xml,<svg height="60" width="60" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor"%0A  viewBox="0 0 3947 3947">%0A  <defs>%0A    <clipPath id="a">%0A      <circle cx="1973.5" cy="1973.5" r="1380" />%0A    </clipPath>%0A  </defs>%0A  <path stroke-dasharray="1706" stroke-width="150" d="M2590.15 1018.5H883.997" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0; 0.12; 0.32; 0.61; 0.70; 1"%0A      repeatCount="indefinite" values="5118; 5118; 3412; 3412; 1706; 1706;" />%0A  </path>%0A  <path stroke-dasharray="2232.73" stroke-width="150" d="M2279 1100 730.001 2708" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.16;0.4;0.65;0.74;1"%0A      repeatCount="indefinite" values="6698.19;6698.19;4465.46;4465.46;2232.73;2232.73;" />%0A  </path>%0A  <path stroke-dasharray="1822" stroke-width="150" d="M1961 1600v1822" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.23;0.4;0.72;0.81;1"%0A      repeatCount="indefinite" values="5466;5466;3644;3644;1822;1822;" />%0A  </path>%0A  <path stroke-dasharray="1330.8" stroke-width="150" d="m2029 2082 936 946" clip-path="url(%23a)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.28;0.4;0.77;0.86;1"%0A      repeatCount="indefinite" values="3992.4;3992.4;2661.6;2661.6;1330.8;1330.8;" />%0A  </path>%0A  <circle cx="1973.5" cy="1973.5" r="1452.5" stroke-dasharray="9126.33" stroke-width="150"%0A    transform="rotate(-21 1973.5 1973.5)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.45;0.50;1" repeatCount="indefinite"%0A      values="0;9126.33;9126.33;18252.66;" />%0A  </circle>%0A  <circle cx="1973.5" cy="1973.5" r="1452.5" stroke-dasharray="20 9126.33" stroke-width="148" color="%23000"%0A    transform="rotate(-21.5 1973.5 1973.5)" />%0A  <circle cx="2674.5" cy="1719.5" r="705.5" stroke-dasharray="4432.79" stroke-width="150"%0A    transform="rotate(-22.28 2674.5 1719.5)">%0A    <animate attributeName="stroke-dashoffset" begin="0s" dur="2s" keyTimes="0;0.45;0.50;1" repeatCount="indefinite"%0A      values="4432.79;8865.58;8865.58;13298.37;" />%0A  </circle>%0A</svg>';var Ga={xs:"24px",s:"32px",m:"48px"};function Or({size:e="s"}){return jsx("img",{src:Ar,width:Ga[e],alt:"..."})}var Ka={top:"column",bottom:"column-reverse",left:"row",right:"row-reverse"};function _r({icon:e$1,align:t="bottom",size:o="s",children:r,...n}){return jsxs(k,{flexDirection:Ka[t],alignItems:"center",...n,children:[jsx(a,{p:"s",children:e$1||jsx(Or,{size:o})}),!he.isNil(r)&&jsx(a,{p:"s",children:jsx(e,{children:r})})]})}var Vr=defineMessages({dismiss:{id:"uikit.banner.dismiss",defaultMessage:"Dismiss"}});function Gr({type:e$1="warning",icon:t,title:o,action:r,onAction:n,canDismiss:i=!0,onDismiss:a$1,description:s,isActionDisabled:p,isLoading:d,...m}){let{formatMessage:f}=useLocales(),c="attention";return jsx(Qa,{type:e$1,pt:"m",pb:"m",pr:"lm",pl:"lm",alignItems:"center",justifyContent:"center",flexWrap:"wrap",...m,children:d?jsx(_r,{}):jsxs(Fragment,{children:[t&&jsx(ja,{pr:"m",flexDirection:"column",flex:"0 0",isAttention:e$1===c,children:t}),jsxs(k,{pr:"m",flexDirection:"column",flex:"10 1 250px",children:[o&&jsx(a,{pb:s?"xs":void 0,children:jsx(e,{fontWeight:"bold",children:o})}),s&&jsx(j,{children:s})]}),(n&&r||i&&a$1)&&jsxs(k,{justifyContent:e$1===c?"flex-end":"space-between",flex:"1 1 0",children:[n&&r&&jsx(Ja,{"data-test":"sr-banner-action-button",variant:e$1===c?"primary":"secondary",size:"s",onClick:n,disabled:p,isAttention:e$1===c,children:r}),a$1&&i&&jsx(G,{"data-test":"sr-banner-dismiss-button",variant:"tertiary",icon:"VMSWeb-close",onClick:a$1,children:f(Vr.dismiss)})]})]})})}var Qa=Ze(k)`
  ${e=>e.type!=="attention"&&css`
      border-radius: 4px;
      border: 2px solid ${e.theme.colors[e.type]};
    `}
  background-color: ${e=>e.type==="attention"?e.theme.colors.highlight:e.theme.colors[`${e.type}Background`]};
`,Ja=Ze(G)`
  background-color: ${e=>e.isAttention?`${e.theme.colors.primaryButton} !important`:e.theme.colors.inputBackground};

  ${e=>e.isAttention&&css`
      padding: 0 1em !important;
    `}
`,ja=Ze(k)`
  ${e=>e.isAttention&&css`
      & > i {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        width: 2em;
        height: 2em;
        border-radius: 50%;
        background-color: white;
        color: ${e.theme.colors.primaryButton};
    `}
`;function Ku({banners:e,setBanners:t}){let o=n=>t(e.filter(i=>i.key!==n)),r=n=>{n.onDismiss?.(),o(n.key);};return jsx(Fragment,{children:e.map((n,i)=>jsx(a,{pb:i+1!==e.length?"m":void 0,children:jsx(Gr,{...n,onDismiss:()=>r(n)})},n.key))})}var ih=Ze(a)`
  border: 1px solid ${f.colors.dividerLines};
  border-radius: 4px;
  box-sizing: border-box;
  height: ${e=>e.height};
`;var Ur=defineMessages({breadcrumbs:{id:"uikit.breadcrumbs.breadcrumbs",defaultMessage:"breadcrumbs"}});function xh(e){let{formatMessage:t}=useLocales();return jsx(ss,{children:jsx(Breadcrumbs,{"aria-label":e.ariaLabel??t(Ur.breadcrumbs),separator:e.separator?e.separator:jsx(a,{pt:"xxs",children:jsx(e$1,{name:"VMSWeb-chevron-right"})}),...e})})}var ss=Ze.div`
  .MuiBreadcrumbs-li {
    appearance: auto;
  }

  .MuiBreadcrumbs-separator {
    margin-left: ${e=>e.theme.spacing.xs};
    margin-right: ${e=>e.theme.spacing.xs};
  }
`;function Xr({children:e,variant:t="primary",flexDirection:o="column",backgroundColor:r,borderColor:n,...i}){return jsx(cs,{variant:t,position:"relative",width:"100%",backgroundColor:r||t==="secondary"&&"secondaryBackground",borderColor:n||t==="primary"&&"borders",flexDirection:o,borderRadius:"s",...i,children:e})}var cs=Ze(l)`
  overflow: hidden;

  ${e=>e.hoverable&&css`
      cursor: pointer;
      &:hover {
        background-color: ${t=>t.theme.colors.inputHoverBackground};
      }
      ${F} {
        background-color: transparent;
      }
    `}
`;function Kr({as:e,...t}){return jsx(gs,{...t})}var gs=Ze(a)`
  ${e=>e.onClick&&css`
      cursor: pointer;
    `}
`;function de(e){return jsx(bs,{...e})}var bs=Ze.div`
  ${e=>e.collapsed&&css`
      height: 0px;
      overflow: hidden;
    `}
`;function Jr({hideLast:e=!1,content:t,...o}){return jsxs(Ss,{"align-items":"center",hideLast:e,children:[jsx(Yr,{...o}),t&&jsxs(Fragment,{children:[t,jsx(Yr,{...o})]})]})}var Yr=Ze.hr`
  border: none;
  height: 1px;
  color: ${e=>e.color?e.theme.colors[e.color]:e.theme.colors.dividerLines};
  background-color: ${e=>e.color?e.theme.colors[e.color]:e.theme.colors.dividerLines};
  margin: ${e=>e.theme.spacing[e.margin??"s"]};
  ${e=>e.ml&&`margin-left: ${e.theme.spacing[e.ml]};`}
  ${e=>e.mr&&`margin-right: ${e.theme.spacing[e.mr]};`}
  ${e=>e.mt&&`margin-top: ${e.theme.spacing[e.mt]};`}
  ${e=>e.mb&&`margin-bottom: ${e.theme.spacing[e.mb]};`}
  width: 100%;
`,Ss=Ze(k)`
  &:last-child {
    ${e=>e.hideLast&&"display: none;"}
  }
`;function qh({template:e,variablesFromTemplate:t,variables:o,venueName:r,height:n,scale:i}){let[a,s]=useState(()=>jr({template:e,variablesFromTemplate:t,variables:o})),p=useThrottledCallback(()=>{let d=jr({template:e,variablesFromTemplate:t,variables:o});i!=null&&(d=d.replace("<head>",`<head>
          <style>
            body {
              display: flex;
              justify-content: center;
              margin: 0;
              transform: scale(${i});
              transform-origin: 50% 0;
            }
          </style>
        `)),!o.venue_logo&&r&&(d=d.replace(/<[^>]*{{venue_logo}}[^>]*>/gi,r)),s(d);},500);return useEffect(()=>{p.callback();},[o,e,p]),jsx(ks,{srcDoc:a,height:n,"data-test":"sr-email-preview-iframe"})}var jr=({template:e,variablesFromTemplate:t,variables:o})=>t.reduce((r,n)=>{let i=o[n];return i?r.replace(new RegExp(`{{${n}}}`,"ig"),String(i)):r},e),ks=Ze.iframe`
  flex-grow: 1;
  border: none;
  border-radius: 4px;
  height: ${e=>e.height??e.theme.imageUploader.height};
`;function $s(e,t){return jsx(l,{...e,ref:t,flexDirection:"row"})}var P=Y.forwardRef($s);function sx({includeNavWidth:e=!1,children:t,...o}){return jsx(Ms,{alignItems:"center",height:"56px",width:"100%",pl:"lm",pt:"sm",pr:"lm",pb:"sm",spacing:"l",includeNavWidth:e,...o,children:t})}var Ms=Ze(P)`
  position: fixed;
  width: ${e=>e.includeNavWidth?`calc(100% - ${e.theme.sizes.sideNavWidth} - ${e.theme.sizes.tabsNavWidth})`:"100%"};
  bottom: 0;
  background-color: ${e=>e.theme.colors.primaryBackground};
  border: 1px solid ${e=>e.theme.colors.margin};
  box-sizing: border-box;
  box-shadow: ${e=>e.theme.shadows.primaryUp};
  border-radius: 8px 8px 0 0;
`;var tn=defineMessages({footerTotalItemSeparator:{id:"footer.item.total.separator",defaultMessage:"of {amount}"}});function xx({primary:e$1,secondary:t,label:o,info:r}){let{formatMessage:n}=useLocales(),i=t!==void 0;return jsxs(P,{spacing:"sm",alignItems:"center",children:[jsxs(P,{alignItems:"center",spacing:"xs",children:[jsx(e,{lineHeight:"s",fontSize:"xl",color:"primarySelected",children:i?t:e$1}),i&&jsx(e,{color:"primarySelected",children:n(tn.footerTotalItemSeparator,{amount:e$1})})]}),jsxs(P,{spacing:"s",children:[jsx(j,{fontSize:"s",children:o}),r&&jsx(O,{tooltip:{content:r},"data-test":"sr-additional-information"})]})]})}function Fs(e,t){return jsx(zs,{...e,display:"grid",ref:t})}var yt=forwardRef(Fs),zs=Ze(a)`
  grid-template-columns: ${e=>e.gridTemplateColumns};
  grid-template-rows: ${e=>e.gridTemplateRows};
  grid-template-areas: ${e=>e.gridTemplateAreas};
  grid-template: ${e=>e.gridTemplate};
  grid-auto-columns: ${e=>e.gridAutoColumns};
  grid-auto-rows: ${e=>e.gridAutoRows};
  grid-auto-flow: ${e=>e.gridAutoFlow};
  grid: ${e=>e.grid};
  grid-row-start: ${e=>e.gridRowStart};
  grid-column-start: ${e=>e.gridColumnStart};
  grid-row-end: ${e=>e.gridRowEnd};
  grid-column-end: ${e=>e.gridColumnEnd};
  grid-row: ${e=>e.gridRow};
  grid-column: ${e=>e.gridColumn};
  grid-area: ${e=>e.gridArea};
  align-items: ${e=>e.alignItems};
  justify-items: ${e=>e.justifyItems};

  ${e=>!he.isNil(e.gap)&&css`
      gap: ${b(e,e.gap)};
    `}

  ${e=>!he.isNil(e.rowGap)&&css`
      row-gap: ${b(e,e.rowGap)};
    `}


    ${e=>!he.isNil(e.columnGap)&&css`
      column-gap: ${b(e,e.columnGap)};
    `}
`;function so(e){let t=useRef(null);return useEffect(()=>{t.current&&e.fetchPriority&&(t.current.fetchPriority=e.fetchPriority);},[e.fetchPriority]),jsx(_s,{ref:t,...e})}var _s=Ze.img`
  ${e=>e.centered&&css`
      object-fit: cover;
      object-position: center;
    `}
  ${e=>e.borderRadius&&css`
      border-radius: ${e.theme.borderRadius[e.borderRadius]};
    `}
  ${e=>e.maxWidth&&css`
      max-width: ${e.maxWidth};
    `}
  ${e=>e.objectFit&&css`
      object-fit: ${e.objectFit};
    `}
`,rn=Ze(so)`
  max-width: ${e=>e.maxWidth??"100%"};
  max-height: ${e=>e.maxHeight??"100%"};

  ${e=>e.height!==void 0&&css`
      min-height: ${e.height};
    `}
`;function _x({imageUrl:e,fallback:t,onImageLoadFailure:o,...r}){let[n,i]=useState(!!e);return n?jsx(so,{src:e??"",onError:()=>{o?.(),i(!1);},...r}):t}function Ys({cropData:e,onError:t,src:o,width:r,height:n,...i}){let a=useRef(null),s=typeof r=="string"?parseFloat(r):r,p=typeof n=="string"?parseFloat(n):n,d=useRef(new Image(s,p));return d.current.onload=()=>{let m=a.current,f=m?.getContext("2d");if(!m||!f){t?.();return}let{x:c,y:b,width:g,height:y}=Zs(e),h=c/100*d.current.naturalWidth,S=b/100*d.current.naturalHeight,T=g/100*d.current.naturalWidth,C=y/100*d.current.naturalHeight;m.width=s||T,m.height=p||C,f.drawImage(d.current,h,S,T,C,0,0,m.width,m.height);},d.current.onerror=t??null,d.current.src=o,jsx(Qs,{ref:a,role:"img",canvasHeight:n,canvasWidth:r,...i})}var qs=e=>Object.values(e).every(t=>t>0),Zs=e=>qs(e)?{...e,width:e.x+e.width>100?100-e.x:e.width,height:e.y+e.height>100?100-e.y:e.height}:{x:0,y:0,width:100,height:100},Qs=Ze.canvas`
  ${e=>css`
    width: ${e.canvasWidth};
    height: ${e.canvasHeight};
  `}
`;var Be="#eee",an=Ze(k)`
  background-image: linear-gradient(45deg, ${Be} 25%, transparent 25%, transparent 75%, ${Be} 75%, ${Be}),
    linear-gradient(45deg, ${Be} 25%, transparent 25%, transparent 75%, ${Be} 75%, ${Be});
  background-size: 20px 20px;
  background-position: 0 0, 10px 10px;
`;var ol="default"in lo?lo.default:lo;function sb({url:e,image:t,crop:o,onError:r,options:n,unit:i="px"}){let a=useMemo(()=>{if(o.rect&&t.dimension&&i==="%")return {...o.rect,unit:i};if(o.rect&&t.dimension)return {x:o.rect.x/t.dimension.scaleX,width:o.rect.width/t.dimension.scaleX,y:o.rect.y/t.dimension.scaleY,height:o.rect.height/t.dimension.scaleY,unit:i}},[o,t.dimension,i]),s=useCallback((d,m)=>{t.dimension&&i==="%"?o.setRect(m):t.dimension&&o.setRect({x:d.x*t.dimension.scaleX,width:d.width*t.dimension.scaleX,y:d.y*t.dimension.scaleY,height:d.height*t.dimension.scaleY,unit:i});},[o,t.dimension,i]),p=useMemo(()=>{let d="unset";return !t.element&&t.naturalSize&&(d=`${100*(t.naturalSize.height/t.naturalSize.width)}%`),d},[t]);return useEffect(()=>()=>t.setElement(void 0),[e]),jsx(rl,{children:e&&jsx(nl,{maxWidth:t.naturalSize&&`${t.naturalSize.width}px`||"unset",onDoubleClick:o.selectAll,children:jsx(il,{spacePlaceholder:p,"data-test":"sr-logo-editor-crop-section",children:jsx(ol,{...n,crop:a,onChange:s,keepSelection:!0,children:jsx("img",{src:e,alt:"being croped",onLoad:d=>t.setElement(d.currentTarget),onError:r})})})})})}var rl=Ze(an)`
  width: 100%;
  align-items: center;
  justify-content: center;
`,nl=Ze.div`
  max-width: ${e=>e.maxWidth};
`,I=11,L=5,il=Ze.div`
  margin: auto;
  display: flex;
  width: 100%;
  max-width: ${e=>e.spacePlaceholder};

  .ReactCrop {
    max-height: initial;
  }

  .ReactCrop__crop-selection {
    border: none;
  }

  .ReactCrop__drag-handle {
    margin: 0 !important;
  }
  .ReactCrop__drag-handle::after,
  .ReactCrop__drag-handle::before {
    border: none;
    outline: none;
    background-color: ${e=>e.theme.colors.primaryButton};
  }

  .ReactCrop__drag-handle::before {
    content: '';
    display: block;
    position: absolute;
    box-sizing: border-box;
  }

  .ReactCrop__drag-handle.ord-nw:after {
    width: ${I}px;
    height: ${L}px;
  }

  .ReactCrop__drag-handle.ord-nw:before {
    width: ${L}px;
    height: ${I}px;
  }

  .ReactCrop__drag-handle.ord-n:after {
    width: ${I}px;
    height: ${L}px;
    margin-left: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-ne:after {
    width: ${I}px;
    height: ${L}px;
    margin-left: -${I}px;
  }

  .ReactCrop__drag-handle.ord-ne:before {
    width: ${L}px;
    height: ${I}px;
    margin-left: -${L}px;
  }

  .ReactCrop__drag-handle.ord-w:after {
    width: ${L}px;
    height: ${I}px;
    margin-top: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-e:after {
    width: ${L}px;
    height: ${I}px;
    margin-left: -${L}px;
    margin-top: -${I/2}px;
  }

  .ReactCrop__drag-handle.ord-sw:after {
    width: ${I}px;
    height: ${L}px;
    margin-top: -${I}px;
  }

  .ReactCrop__drag-handle.ord-sw:before {
    width: ${L}px;
    height: ${I}px;
    margin-top: -${I}px;
  }

  .ReactCrop__drag-handle.ord-s:after {
    width: ${I}px;
    height: ${L}px;
    margin-left: -${I/2}px;
    margin-top: -${L}px;
  }

  .ReactCrop__drag-handle.ord-se:after {
    width: ${I}px;
    height: ${L}px;
    margin-left: -${I/2}px;
    margin-top: -${L}px;
  }

  .ReactCrop__drag-handle.ord-se:before {
    width: ${L}px;
    height: ${I}px;
    margin-left: -${L}px;
    margin-top: -${I}px;
  }

  @media (pointer: coarse) {
    .ReactCrop__drag-handle {
      width: inherit;
      height: inherit;
    }
  }
`;var ln="data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=",cb=(e,t,o)=>!e||!t||!o?ln:al(e,o)??ln,al=(e,t)=>{let o=document.createElement("canvas"),r=o.getContext("2d"),n=t.unit==="%"?t.x*e.naturalWidth/100:t.x,i=t.unit==="%"?t.y*e.naturalHeight/100:t.y,a=t.unit==="%"?t.width*e.naturalWidth/100:t.width,s=t.unit==="%"?t.height*e.naturalHeight/100:t.height;return o.width=a,o.height=s,r?.drawImage(e,n,i,a,s,0,0,a,s),o.toDataURL("image/png")};var sl=30;function fb({minHeight:e=sl,maxHeight:t,maxWidth:o,currentHeight:r},n={width:1,height:1,x:1,y:1}){let i=Y__default.useMemo(()=>n.width/n.height,[n]),a=Y__default.useCallback(m=>{let f=i*m;return f>o?f/n.width*n.height:m},[n,i,o]),[s,p]=Y__default.useMemo(()=>{let m=Math.min(n.height,r),f=m,c=i*m;return c>o&&(c=o,f=c/n.width*n.height),[c,f]},[n,r,o]),d=Y__default.useMemo(()=>({min:a(e),max:a(t),calculatedWidth:s,calculatedHeight:p}),[a,e,t,s,p]);return Y__default.useMemo(()=>({byHeight:d}),[d])}function hb(e,t,o,r="px"){let[n,i]=useState(t),a=useRef(e.element),s=useMemo(()=>n?!n.height&&!n.width:!0,[n]),p=useCallback(()=>{if(e.naturalSize){let{width:d,height:m}=e.naturalSize,f={x:0,y:0,unit:n?.unit??r};if(!o){i({...f,width:f.unit==="%"?100:d,height:f.unit==="%"?100:m});return}let c=d/m;f.unit==="%"?i({...f,width:c<o?100:100*o/c,height:c<o?100*c/o:100}):i({...f,width:c<o?d:m*o,height:c<o?d/o:m});}},[e.naturalSize,n?.unit,r,o]);return useEffect(()=>{a.current&&a.current!==e.element&&i(void 0),a.current=e.element;},[e.element]),useEffect(()=>{s&&p();},[s,p]),{rect:n,setRect:i,selectAll:p}}function yb(e){let[t,o]=useState(void 0),[r,n]=useState(e),i=useMemo(()=>t?{width:t.naturalWidth,height:t.naturalHeight}:r,[r,t]);useEffect(()=>()=>n(void 0),[t]);let a=useMemo(()=>t?{width:t.width,height:t.height,scaleX:t.naturalWidth/t.width,scaleY:t.naturalHeight/t.height}:void 0,[t]);return {element:t,setElement:o,dimension:a,naturalSize:i}}function Eb({images:e,height:t}){return jsx(n$1,{alignItems:"center",justifyContent:"center",width:"100%",height:"100%",borderRadius:"s",overflow:"hidden","data-test":"room-images",children:jsx(xl,{showDots:!0,dots:jsx(gl,{}),showArrows:!0,arrows:jsx(ul,{}),children:e.map(o=>jsx(hl,{src:o,maxHeight:t,width:"100%",alt:"image"},o))})})}function gl(){let{totalPages:e,currentPage:t,goToPage:o}=useCarousel();return jsx(P,{spacing:"s",mt:"sm",children:[...Array(e)].map((r,n)=>jsx(bl,{onClick:()=>o(n),isActive:n===t,"data-test":`${n+1}-dot`},`${n}-dot`))})}function ul(){let{currentPage:e,totalPages:t,goBack:o,goForward:r}=useCarousel(),n=e>0,i=e<t-1;return jsxs("div",{children:[jsx(pn,{p:"none m",visibility:n?"initial":"hidden",children:jsx(x,{icon:"VMSWeb-chevron-left",iconBackgroundColor:"primaryBackground","data-test":"chevron-left",onClick:o})}),jsx(pn,{p:"none m",isRight:!0,visibility:i?"initial":"hidden",children:jsx(x,{icon:"VMSWeb-chevron-right",iconBackgroundColor:"primaryBackground","data-test":"chevron-right",onClick:r})})]})}var hl=Ze.img`
  object-fit: cover;
  object-position: center center;
  min-width: 100%;
  max-height: ${e=>e.maxHeight||"100%"};
`,xl=Ze(Carousel)`
  width: 100%;
`,bl=Ze(G)`
  padding: 0;
  width: 8px;
  height: 8px;
  background-color: ${e=>e.isActive?e.theme.colors.brandColor:e.theme.colors.primaryBackground};
  border: ${e=>`${e.theme.borderWidth.s} solid ${e.theme.colors.secondaryFont}`};
`,pn=Ze(a)`
  position: absolute;
  top: calc(50% - 2rem);
  right: ${e=>e.isRight?0:"auto"};
`;var gn=defineMessages({footerLabel:{id:"footer.label",defaultMessage:"Experience by"},footerImageLabel:{id:"footer.image.label",defaultMessage:"SEVENROOMS"}});var vl="https://sevenrooms.com";function Xb({showTopBorder:e=!0}){let{formatMessage:t}=useLocales(),{footer:{height:o}}=c(),r="s";return jsx(P,{height:o,"data-test":"footer",backgroundColor:"primaryBackground",borderTopColor:e?"borders":void 0,alignItems:"center",justifyContent:"center",width:"100%",p:`${r} none`,spacing:r,tabIndex:0,children:jsx(ExperienceBySevenRooms,{href:vl,experienceByText:t(gn.footerLabel)})})}var hn=defineMessages({linkAreaLabel:{id:"logoImage.link.areaLabel",defaultMessage:"{name} logo"}});function xn({baseUrl:e$1,target:t="_self",logo:o,logoLabel:r,height:n="100%","data-test":i}){let{formatMessage:a}=useLocales();return jsx($l,{height:"100%",cursor:"pointer","data-test":i,children:jsx(e,{lineHeight:"none",children:jsx(Link,{"data-test":"logo-link",to:e$1,isExternal:!0,target:t,"aria-label":a(hn.linkAreaLabel,{name:r}),children:jsx(rn,{"data-test":"logo-image",src:o,height:n,alt:r,fetchPriority:"high"})})})})}var $l=Ze(a)`
  transition: ${e=>`opacity ${e.theme.animation.duration.logo} ${e.theme.animation.easing.easeInOut}`};

  &:hover {
    opacity: 0.7;
  }
`;function vt({"data-test":e,ariaLabel:t,width:o,minWidth:r$1,maxWidth:n,maxHeight:i,children:a}){let s=Y.useRef(null),p=typeof o=="number"?`${o}px`:o;return jsx(Il,{onClick:d=>d.stopPropagation(),"data-test":e,role:"dialog","aria-label":t,width:p,maxHeight:i,children:jsx(Bl,{children:jsxs(Ml,{pl:"lm",pr:"lm",children:[jsx(r,{}),jsx(Ll,{minWidth:r$1,maxWidth:n,width:p,ref:s,children:a})]})})})}var Il=Ze.div`
  margin: auto;
  display: flex;
  justify-content: center;
  width: ${({width:e})=>e?`${e}`:"fit-content"};
  max-height: ${({maxHeight:e})=>e??"100%"};
`,Ml=Ze(a)`
  display: flex;
  width: 100%;
  max-height: 100%;
`,Ll=Ze.div`
  display: flex;
  flex-flow: column;
  margin: 0 auto;
  background-color: ${e=>e.theme.colors.primaryBackground};
  width: ${({width:e})=>e?`${e}`:"min-content"};
  min-width: ${({minWidth:e,theme:t})=>e?`${e}`:t.modal.minimalWidth};
  max-width: ${({maxWidth:e,theme:t})=>e?`${e}`:t.modal.maximumWidth};
  box-shadow: ${e=>e.theme.shadows.tertiary};
  border-radius: ${e=>e.theme.modal.borderRadius};
  overflow: auto;
`;function Sn(e){return jsx(k,{justifyContent:"flex-end",children:jsx(P,{spacing:"s",children:e.children})})}function Fl(e,t){return jsx(TouchScrollable,{children:o=>jsx(a,{pl:"lm",pr:"lm",overflow:"auto",backgroundColor:"primaryBackground",ref:On([o,t]),...e,children:e.children})})}var Pn=forwardRef(Fl);function vn({children:e,...t}){return jsx(Dl,{p:"lm",...t,children:e})}var Dl=Ze(a)`
  flex-shrink: 0;
  border-bottom-left-radius: ${e=>e.theme.modal.borderRadius};
  border-bottom-right-radius: ${e=>e.theme.modal.borderRadius};
  background: ${e=>e.theme.colors.primaryBackground};
`;function Gl({href:e,size:t,icon:o,iconSize:r,iconColor:n,isExternal:i,...a},s){return jsx(Ul,{ref:s,to:e,isExternal:i,size:t,borderType:"none-round",...a,children:jsx(e$1,{size:r,name:o,color:n})})}var wn=forwardRef(Gl),Ul=Ze(Link)`
  ${y}
  text-decoration: none;

  // Need to increase specificity to override a global css style applied by
  // nightloop.css. https://sevenrooms.atlassian.net/browse/ORDER-815
  &&:hover {
    text-decoration: none;
  }
  &:active {
    // Override anchor's default browser style for active link
    color: inherit;
  }
`;function Tt({children:e,onClose:t,closeHref:o,disabled:r,...n}){return jsxs(Xl,{pt:"lm",pb:"m",pl:"lm",pr:"m",...n,children:[e,jsx(Kl,{children:o?jsx(wn,{href:o,size:"s",icon:"VMSWeb-close",iconColor:"primaryIcons",iconSize:"lg","aria-label":"close","data-test":"ui-kit-modal-close"}):jsx(x,{size:"s",borderType:"none-round",icon:"VMSWeb-close",iconColor:"primaryIcons",onClick:t,"aria-label":"close","data-test":"ui-kit-modal-close",disabled:r})})]})}var Xl=Ze(a)`
  flex-shrink: 0;
  border-top-left-radius: ${e=>e.theme.modal.borderRadius};
  border-top-right-radius: ${e=>e.theme.modal.borderRadius};
  background: ${e=>e.backgroundColor??e.theme.colors.primaryBackground};
  display: flex;
`,Kl=Ze(a)`
  flex-shrink: 1;
  align-self: start;
  margin-top: -5px;
  margin-left: auto;
`;function Rn(e$1){return jsxs(n$1,{spacing:"s",flexGrow:1,children:[jsx("div",{children:jsx(M,{type:"h2","data-test":"modal-title",children:e$1.title})}),e$1.subTitle&&jsx("div",{children:jsx(e,{"data-test":"modal-sub-title",children:e$1.subTitle})})]})}var Ye=defineMessages({warning:{id:"unsavedChangesModal.warning",defaultMessage:"Unsaved Changes"},title:{id:"unsavedChangesModal.title",defaultMessage:"Are you sure you want to leave without saving?"},back:{id:"unsavedChangesModal.back",defaultMessage:"Back to Editing"},discard:{id:"unsavedChangesModal.discard",defaultMessage:"Exit Without Saving"}});function mS({onCancel:e,onDiscard:t}){let{formatMessage:o}=useLocales();return jsxs(vt,{ariaLabel:"Modal",minWidth:528,children:[jsx(Tt,{pb:"none",onClose:()=>e?.(),children:jsxs(n$1,{spacing:"s",children:[jsx(Z,{kind:"error",children:o(Ye.warning)}),jsx(Rn,{title:o(Ye.title)})]})}),jsx(vn,{children:jsxs(Sn,{children:[jsx(G,{variant:"secondary",onClick:()=>e?.(),"data-test":"unsaved-modal-cancel",children:o(Ye.back)}),jsx(G,{variant:"primary-warning",onClick:()=>t?.(),"data-test":"unsaved-modal-save",children:o(Ye.discard)})]})})]})}function IS({fieldArray:e,renderItem:t,item:o,label:r,"data-test":n}){return jsxs(n$1,{"data-test":n,spacing:"s",alignItems:"flex-start",children:[e.map((i,a$1,s)=>jsxs(P,{"data-test":`multiline-item-${s}`,spacing:"s",alignItems:"center",children:[t(i,s),jsx(a,{children:e.size()>1?jsx(x,{"data-test":"multiline-remove",borderType:"none-round",size:"s",icon:"VMSWeb-close",onClick:()=>i.remove()}):jsx(a,{p:"m"})})]},a$1.id)),jsxs(G,{"data-test":"multiline-add",variant:"tertiary",noPadding:!0,onClick:()=>e.append(o),children:["+\xA0",r]})]})}function $n({...e}){return jsx(ed,{draggable:!1,closeOnClick:!1,rtl:!1,hideProgressBar:!0,...e})}var ed=Ze(ToastContainer)`
  min-width: 436px;

  @keyframes Toastify__fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes Toastify__fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }

  .Toastify__fade-enter {
    animation: Toastify__fadeIn 0.5s ease-in both;
  }

  .Toastify__fade-exit {
    animation: Toastify__fadeOut 0.5s ease-out both;
  }

  .Toastify__toast-container--bottom-left {
    left: 7em;
  }

  .Toastify__toast {
    min-height: auto;
    padding: ${e=>e.theme.spacing.s} ${e=>e.theme.spacing.m};
    box-shadow: ${e=>e.theme.shadows.secondary};
  }

  .Toastify__toast-body {
    padding: 0;
    font-size: ${e=>e.theme.fontSizes.m};
    line-height: ${e=>e.theme.lineHeights.s};
  }

  .Toastify__toast--error {
    background-color: ${e=>e.theme.colors.error};
  }

  .Toastify__toast--warning {
    background-color: ${e=>e.theme.colors.warning};
  }

  .Toastify__toast--success {
    background-color: ${e=>e.theme.colors.success};
  }

  &.Toastify__toast-container {
    z-index: ${e=>e.theme.zIndex.toaster};
    width: auto;
    min-width: 320px;
    max-width: min-content;
  }

  &.Toastify__toast-body {
    word-break: break-all;
    width: 100%;
  }
`;var dd=cssTransition({enter:"Toastify__fade-enter",exit:"Toastify__fade-exit"}),cd={fade:dd,slide:Slide,bounce:Bounce,zoom:Zoom,flip:Flip};function US({content:e,type:t="warning",position:o="bottom-left",button:r=jsx(e$1,{name:"VMSWeb-close"}),action:n,autoClose:i=5e3,animation:a="fade",style:s,...p}){let d=r&&(({closeToast:m})=>jsx(md,{"data-test":"sr-notification-close-button",variant:"tertiary",onClick:()=>{n?.(),m();},children:r}));toast[t](e,{position:o,closeButton:d,pauseOnHover:!0,autoClose:i,style:{zIndex:f.zIndex.toaster,...s},transition:cd[a],...p});}var md=Ze(G)`
  padding: 0 ${e=>e.theme.spacing.s};
  color: ${e=>e.theme.colors.lightFont} !important;

  &:focus,
  &:hover,
  &:active {
    color: ${e=>e.theme.colors.lightFont} !important;
  }
`;var In={info:"primaryIcons",error:"error",warning:"warning",success:"success"},pd={info:"infoBackground",error:"errorBackground",warning:"warningBackground",success:"successBackground"},fd={info:"GX-info-outline",error:"GX-warning",warning:"GX-warning",success:"GX-checkbox-marked-circle"};function eC({content:e$2,type:t,showIcon:o,iconName:r,...n}){return jsxs(Xr,{backgroundColor:pd[t],borderColor:In[t],flexDirection:"row",alignItems:"center",spacing:"s",p:"m",...n,children:[o&&jsx(e$1,{color:In[t],size:"lg",name:r??fd[t],"data-test":"notification-banner-icon"}),jsx(e,{"data-test":"notification-banner-content",wordBreak:"break-word",children:e$2})]})}function Wn({show:e,children:t,enableAutoFocus:o=!0,enableReturnFocus:r$1=!1,enableScrollLock:n=!0,enableBackdrop:i=!0,enableFocusLock:a=!0,shouldCloseOnClick:s$1=!0,shouldCloseOnEscapePress:p=!0,handleFocusableElements:d=!1,onBeforeClose:m=he.noop,onEnter:f=he.noop,onEntering:c=he.noop,onEntered:b=he.noop,onExit:g=he.noop,onExiting:y=he.noop,onExited:h=he.noop}){let[S,T]=useState(e?0:2);useEffect(()=>{e&&S===2&&T(0);},[e,S]);function C(k){T(2),h(k);}function w(){m()!==!1&&T(1);}function $(k){k.target===k.currentTarget&&s$1&&w();}let M=useTheme(),ne=useMemo(()=>ud.from(M.animation.duration.overlay),[M.animation.duration.overlay]);return S===2?null:jsx(s,{index:M.zIndex.overlay,children:k=>jsx(u$1,{children:jsx(Transition,{appear:!0,unmountOnExit:!0,in:e&&S!==1,timeout:ne,onEnter:f,onEntering:c,onEntered:b,onExit:g,onExiting:y,onExited:C,children:ge=>jsx(r,{isActive:n,children:jsxs(Bl,{disabled:!a,autoFocus:o,returnFocus:r$1,children:[jsx(wd,{enabled:i,zIndex:k,"data-state":ge,onClick:$,children:typeof t=="function"?t({state:ge,close:w}):t}),jsx(Sd,{handleKeys:["esc"],isDisabled:!p,onKeyEvent:w,handleFocusableElements:d})]})})})})})}var wd=Ze.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: ${e=>e.zIndex};
  background-color: ${e=>e.enabled?"rgba(10, 10, 10, 0.3)":"transparent"};
  pointer-events: ${e=>e.enabled?"all":"none"};

  > * {
    pointer-events: all;
  }

  ${({theme:{animation:e}})=>css`
    &[data-state='entering'],
    &[data-state='entered'] {
      animation: ${kd} ${e.duration.overlay} ${e.easing.acceleration} both;
    }

    &[data-state='exiting'],
    &[data-state='exited'] {
      animation: ${Rd} ${e.duration.overlay} ${e.easing.deceleration} both;
    }
  `}
`,kd=keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`,Rd=keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`;function CC({children:e,...t}){return jsx(Id,{pl:"m",...t,children:e})}var Id=Ze(a)`
  border-left: 1px solid ${e=>e.theme.colors.dividerLines};
`;var J=defineMessages({noResult:{id:"uikit.select.noResult",defaultMessage:"No result"},emptyItem:{id:"uikit.select.emptyItem",defaultMessage:"Empty item"},filterInput:{id:"uikit.select.filterInput",defaultMessage:"Filter input"},toggleLabel:{id:"uikit.select.toggleLabel",defaultMessage:"Toggle menu"},readerLabel:{id:"uikit.select.readerLabel",defaultMessage:"Choose an element"}});var Hn=memo(forwardRef(Fd));function Fd({disabled:e,"data-test":t,options:o,withEmpty:r,hideEmptyOption:n,value:i,onChange:a},s){let{formatMessage:p}=useLocales(),d=typeof o[0]?.id=="number",m=useMemo(()=>r&&!n?[null,...o]:[...o],[n,o,r]),f=useMemo(()=>m.find(c=>c?.id===i),[m,i]);return jsxs(zd,{disabled:e,"data-test":t,tabIndex:-1,ref:s,"aria-hidden":"true",value:f?.id??"",onChange:c=>{let b=c.target.value??null;a?.(b&&d?Number(b):b);},children:[m.map(c=>jsx("option",{value:c?.id??"","aria-label":c?.label||p(J.emptyItem),children:c?.label},c?.id??null)),m.length===0&&jsx("option",{disabled:!0,children:p(J.noResult)})]})}var zd=Ze.select`
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${e=>e.theme.zIndex.default};
  opacity: 0;
  cursor: ${e=>e.disabled?"not-allowed":"pointer"};

  @media (hover: hover) and (pointer: fine) {
    display: none;
  }
`;function Le({children:e,"data-test":t="error-message",...o}){return e?jsx(a,{mt:"xs",children:jsx(i,{"data-test":t,...o,children:e})}):null}function _C({"data-test":e,field:t}){let{errors:o}=useFormState({control:t.control}),r=_d(o,t.name);return r.length===0?null:jsx(Le,{"data-test":e,children:r.join(" ")})}function Od(e){return e!=null}function _d(e,t){if(!e)return [];let o=t.split("."),r=e;for(let n of o)if(r!==void 0&&n in r)r=r[n];else return [];return zn(r)}function Vd(e){let t=e.type;return t!==void 0&&typeof t!="object"}function zn(e){if(e){if(Vd(e))return [e.message].filter(Od)}else return [];let t,o=[];for(t in e){let r=e[t];o.push(zn(r));}return o.flat()}function Yd(e,t){function o(r){typeof e.onClick=="function"&&e.onClick(r);}return jsx(ho,{...e,ref:t,onClick:o,type:"button",children:jsx(e$1,{name:"VMSWeb-chevron-down",color:"primaryIcons"})})}var kt=forwardRef(Yd),qd=css`
  > i {
    transition-property: transform;
    transition-duration: ${e=>e.theme.animation.duration.controls};
    transition-timing-function: ${e=>e.theme.animation.easing.spring};
    transform: ${e=>e.open?"rotate(180deg)":"rotate(0deg)"};
    font-size: ${e=>e.theme.fontSizes.l};
  }
`,ho=Ze.button`
  padding: ${e=>`${e.theme.spacing.sm} ${e.theme.spacing.m} ${e.theme.spacing.sm} ${e.theme.spacing.s}`};
  margin: 0;
  height: 100%;
  border: none;
  outline: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  ${qd}
`;var We=memo(forwardRef(tc));function tc({searchable:e=!0,disabled:t,invalid:o$1,initialIsOpen:r,initialInputValue:n$2,contentProps:i,placeholder:a,"data-test":s,useSmartAlignment:p$1=!0,options:d,withEmpty:m,hideEmptyOption:f,value:c,onChange:b,errorMessage:g,hideErrorMessage:y,zIndexLayer:h="popover",scrollLock:S,filterIcon:T,hideFilterIcon:C,onFocus:w$1,onBlur:$,name:M,withNativeSupport:ne=!1,valueIcon:k,displayValue:ge,wrapperProps:tt={},alignment:Gt},jo){let{formatMessage:ve}=useLocales(),er=useRef(null),Ut=useRef(null),tr=useRef([]),[Ve,or]=useState(!1),[ot,rr]=useState(!1),{ref:nr,width:Ca}=jd(),Xt=useMemo(()=>m&&!f?[null,...d]:[...d],[f,d,m]),{result:Ge,setFilter:Kt}=n({options:Xt,optionToString:_n,initialFilter:n$2}),Pa=E=>{let F=E?.selectedItem;F!==void 0&&(Ut.current?.focus(),b?.(F?.id??null));},{isOpen:V,openMenu:Yt,closeMenu:ir,inputValue:ar,selectedItem:Te,getToggleButtonProps:sr,getLabelProps:qt,getMenuProps:va,getInputProps:lr,getComboboxProps:dr,highlightedIndex:Ta,getItemProps:wa}=useCombobox({items:Ge,itemToString:_n,circularNavigation:!0,onSelectedItemChange:Pa,initialIsOpen:r,initialInputValue:n$2,selectedItem:Xt.find(E=>E?.id===c)??null,stateReducer:(E,{type:F,changes:Z})=>{switch(F){case useCombobox.stateChangeTypes.FunctionOpenMenu:{let Zt=E.selectedItem?Xt.indexOf(E.selectedItem):void 0;return {...E,...Z,inputValue:"",highlightedIndex:Zt}}case useCombobox.stateChangeTypes.InputBlur:case useCombobox.stateChangeTypes.ToggleButtonClick:case useCombobox.stateChangeTypes.FunctionCloseMenu:case useCombobox.stateChangeTypes.FunctionToggleMenu:case useCombobox.stateChangeTypes.ItemClick:case useCombobox.stateChangeTypes.InputKeyDownEnter:case useCombobox.stateChangeTypes.InputKeyDownEscape:return {...E,...Z,inputValue:""};case useCombobox.stateChangeTypes.InputChange:return V&&Kt(Z.inputValue||""),{...E,...Z};default:return {...E,...Z}}}}),ka=useCallback(()=>{Te&&tr.current[Ge.indexOf(Te)]?.scrollIntoView?.();},[Ge,Te]),Ra=useCallback(()=>{Kt(""),!ot&&!Ve&&$?.();},[ot,$,Kt,Ve]),$a=useCallback(E=>jsxs(fa$1,{open:V,invalid:o$1,disabled:t,flipped:E.flipped,focused:Ve||ot,...dr({ref:On([nr,E.ref])}),"aria-expanded":V?"true":"false","aria-controls":qt().id,...s&&{"data-test":s},valueIcon:!!k,children:[jsx(da$1,{"aria-label":ve(J.filterInput),tabIndex:Ve?-1:0,searchable:e,selectedValue:Te?.label,displayValue:ge,placeholder:a,filterIcon:T,valueIcon:k,hideFilterIcon:C,...s&&{"data-test":`${s}-filter`},...lr({ref:On([er,jo]),name:M,onFocus:()=>{rr(!0),w$1?.(),V||Yt();},onBlur:F=>{rr(!1),F.relatedTarget!==Ut.current&&!V&&$?.();},onMouseDown:()=>{e||(V?ir():Yt());},disabled:t,value:ar})}),jsx(kt,{...sr({disabled:t,ref:Ut,onFocus:()=>or(!0),onBlur:F=>{or(!1),F.relatedTarget!==er.current&&!V&&$?.();}}),"aria-label":ve(J.toggleLabel),...s&&{"data-test":`${s}-toggle`},open:V}),jsx(ha,{...qt(),children:i?.["aria-label"]||ve(J.readerLabel)})]}),[ir,i,t,ge,T,ot,ve,dr,lr,qt,sr,C,ar,o$1,V,M,$,w$1,Yt,a,jo,e,Te?.label,nr,s,Ve,k]),Ba=va({},{suppressRefError:!0});return jsxs(n$1,{position:ne?"relative":"static",...tt,children:[jsx(w,{show:V,content:({flipped:E})=>jsxs(p,{width:k?212:Ca,flipped:E,...Ba,children:[Ge.map((F,Z)=>jsx(q$1,{"aria-label":F?.label??ve(J.emptyItem),label:F?.label,selected:Te===F,highlighted:Ta===Z,...wa({item:F,index:Z,ref:Zt=>{tr.current[Z]=Zt;}})},F?.id??"empty-item")),Ge.length===0&&jsx(o,{children:ve(J.noResult)})]}),onOpen:ka,onCloseComplete:Ra,alignment:Gt,targetOffset:0,bodyOffset:0,contentProps:i,useSmartAlignment:p$1,zIndexLayer:h,scrollLock:S,"data-test":s?`${s}-popover`:void 0,children:$a}),!y&&jsx(Le,{children:g}),ne&&!e&&jsx(Hn,{value:c,options:d,disabled:t,onChange:b,"data-test":`${s}-native`,withEmpty:m,hideEmptyOption:f})]})}function _n(e){return e?.label??""}var fP=e=>Object.entries(e).map(([t,o])=>({id:t,label:o}));var hP=({max:e,start:t=1,step:o=1,suffix:r="",prefix:n=""})=>{let i=[];for(let a=t;a<=e;a+=o)i.push({id:String(a),label:`${n}${a}${r}`});return i};function Vn({items:e,anchor:t,...o}){let[r,n]=useState(!1),{ref:i,width:a}=jd(),s=css`
    width: ${a}px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: 1px solid ${p=>p.theme.colors.deactivated};
  `;return jsx(A,{onOpen:()=>n(!0),onClose:()=>n(!1),anchor:jsxs(ic,{open:r,children:[jsx(ac,{pl:"m",children:t}),jsx(sc,{open:r})]}),anchorRef:i,rowsStyles:s,targetOffset:"none",...o,children:e.map(p=>jsx(z,{onClick:p.onClick,children:p.label},p.id))})}var ic=Ze(fa$1)`
  cursor: pointer;
`,ac=Ze(a)`
  flex: 1;
  align-self: center;
  white-space: nowrap;
  overflow: hidden;
`,sc=Ze(kt)`
  pointer-events: none;
`;function UP({width:e$1,isShowingSideNavigation:t=!0,venueOptions:o,selectedVenueId:r,onVenueChange:n,profileOptions:i,user:a$1}){let{formatMessage:s}=useLocales(),p=d=>jsxs(k,{maxWidth:"170px",alignItems:"center",children:[jsx(a,{mr:"sm",children:jsx(Er,{firstName:d.first_name,lastName:d.last_name,image:d.photo?.small?`/.h/download/${d.photo.small}`:void 0})}),jsx(e,{textOverflow:"ellipsis",overflow:"hidden",children:d?.first_name})]});return jsxs(pc,{justifyContent:"space-between",width:e$1,isShowingSideNavigation:t,children:[jsx(k,{height:"100%",alignItems:"center",ml:"lm"}),jsxs(P,{height:"100%",spacing:"s",alignItems:"center",justifyContent:"flex-end",mr:"s",children:[jsx(We,{options:o,value:r??null,withEmpty:!0,hideEmptyOption:!0,onChange:n,placeholder:r?void 0:s(commonMessages.loadingVenues),"data-test":"sr-primary-header-venue-menu"}),a$1&&i&&jsx(fc,{children:jsx(Vn,{anchor:p(a$1),items:i,"data-test":"sr-primary-header-user-menu"})})]})]})}var mc=58,pc=Ze(k)`
  width: ${e=>e.width||`calc(100% - (${e.theme.sizes.tabsNavWidth} + ${e.isShowingSideNavigation?e.theme.sizes.sideNavWidth:"0px"}))`};
  height: ${mc}px;
  position: fixed;
  top: 0;
  background: ${e=>e.theme.colors.primaryBackground};
  z-index: ${f.zIndex.navbar};
  box-sizing: border-box;
`,fc=Ze.div`
  flex-basis: 140px;
`;var hc="secondary-header";function av({title:e,breadcrumbs:t,description:o,image:r,tab:n,actions:i,top:a$1=0,width:s,maxWidth:p,textMaxWidth:d="640px",onHeightChange:m,isAdmin:f,backgroundImage:c,isShowingSideNavigation:b=!0}){let[g,y]=Y.useState(!1),h=s$1(g),S=useTheme(),{ref:T,height:C}=D(50,"border-box"),{y:w}=B({y:f?50:j$1(S.spacing.lm)}),{height:$,opacity:M}=useSpring({opacity:g?0:1,height:g?"0%":"100%",config:{duration:150}}),{display:ne,lineHeight:k$1,fontSize:ge,padding:tt}=useSpring({display:g?"initial":"none",lineHeight:g?S.lineHeights.l:S.lineHeights.xl,fontSize:g?S.fontSizes.xl:S.fontSizes.xxl,padding:g?S.spacing.s:S.spacing.lm,config:{duration:150}});return Y.useEffect(()=>{y(w);},[w]),Y.useEffect(()=>{he.isNumber(C)&&m?.(C);},[C,m]),jsxs(Cc,{id:hc,"data-test":"secondary-header",style:{paddingTop:tt,paddingBottom:tt},ref:T,top:f&&w?0:a$1,collapsed:g,pl:"lm",pr:"lm",width:s,backgroundImage:c,isShowingSideNavigation:b,children:[t,jsxs(P,{maxWidth:p,justifyContent:"space-between",alignItems:"center",flexGrow:1,ml:f?"auto":"none",mr:f?"auto":"none",mt:t?"m":"none",children:[jsx(k,{alignSelf:"flex-start",children:jsxs(P,{spacing:"m",alignItems:"center",children:[r&&jsx(yc,{children:r}),jsxs(n$1,{spacing:o&&!g?"s":void 0,alignItems:f?"flex-start":void 0,maxWidth:d,children:[jsxs(k,{alignItems:"center",children:[jsx(a,{mt:g?"s":void 0,mb:g?"s":void 0,children:jsx(Xn,{"data-test":"secondary-header-title",style:{lineHeight:k$1,fontSize:ge,fontWeight:"bold"},children:e})}),n&&jsxs(Xn,{style:{display:ne,lineHeight:S.lineHeights.l,fontSize:S.fontSizes.xl},children:["\xA0-\xA0",n]})]}),jsx(Pc,{style:{opacity:M,height:g&&h===g?$:"auto",display:M.to(Gt=>Gt===0?"none":"initial")},children:jsx(j,{children:o})})]})]})}),i&&jsx(k,{alignSelf:"flex-start",children:jsx(bc,{children:i})})]})]})}var xc=Ze(a)`
  ${e=>e.backgroundImage&&css`
      background: ${e.backgroundImage};
    `}

  width: ${e=>e.width||`calc(100% - (${e.theme.sizes.tabsNavWidth} + ${e.isShowingSideNavigation?e.theme.sizes.sideNavWidth:"0px"}))`};
  box-sizing: border-box;
  background-color: ${e=>e.theme.colors.secondaryBackground};
  position: fixed;
  top: ${e=>`${e.top||0}px`};
  z-index: ${e=>e.theme.zIndex.navbar};
  min-height: 58px;

  ${e=>e.isAdmin&&css`
      left: 0;
    `}

  ${e=>e.collapsed&&css`
      box-shadow: ${e.theme.shadows.primary};
    `};
`,bc=Ze(a)`
  min-height: ${e=>e.theme.fieldHeight.m};
`,yc=Ze(a)``,Sc=Ze(a)`
  line-height: ${e=>`${e.lineHeight} !important`};
  font-size: ${e=>`${e.fontSize} !important`};
`,Xn=animated(Sc),Cc=animated(xc),Pc=Ze(animated.div)`
  will-change: opacity, height;
  overflow: hidden;
`;var Kn=createGlobalStyle`
  .DayPicker {
    font-size: ${e=>e.theme.fontSizes.m};
    font-family: ${e=>e.theme.fonts.primary};

    &_weekHeader {
      color: ${e=>e.theme.colors.primaryFont};
    }

    &_focusRegion {
      box-shadow: ${e=>e.theme.shadows.tertiary};
    }

    .CalendarMonth_caption {
      color: ${e=>e.theme.colors.primaryFont};
      margin-bottom: ${e=>e.theme.spacing.s};
    }

    .CalendarDay {
      font-weight: 300;
      color: ${e=>e.theme.colors.primaryFont};
      border: 1px solid ${e=>e.theme.colors.dividerLines};

      &__highlighted_calendar {
        font-weight: bold;
        &:not(.CalendarDay__selected):not(:hover) {
          background-color: ${e=>e.theme.colors.primaryBackground};
        }
      }

      &__blocked_out_of_range {
        color: ${e=>e.theme.colors.deactivated};
      }

      &__default {
        &:hover {
          background-color: ${e=>e.theme.colors.dividerLines};
        }
      }

      &__selected {
        background-color: ${e=>e.theme.colors.primaryButton};
        border-color: ${e=>e.theme.colors.primaryButton};
        color: ${e=>e.theme.colors.lightFont};

        &:hover {
          background-color: ${e=>e.theme.colors.primaryHover};
        }
      }

      &__today {
        border: 1px solid ${e=>e.theme.colors.primaryButton};
        position: relative;

        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          height: calc(100% + 2px);
          background-color: ${e=>e.theme.colors.primaryButton};
          width: 1px;
        }

        &:after {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          height: 1px;
          background-color: ${e=>e.theme.colors.primaryButton};
          width: calc(100% + 1px);
        }
      }

      &__blocked_calendar {
        position: relative;
        background-color: ${e=>e.theme.colors.secondaryFont};
        border-color: ${e=>e.theme.colors.secondaryFont};
        color: ${e=>e.theme.colors.lightFont};

        &:before {
          content: '';
          position: absolute;
          top: -1px;
          left: -1px;
          height: calc(100% + 2px);
          background-color: ${e=>e.theme.colors.secondaryFont};
          width: 1px;
        }

        &:after {
          content: '';
          position: absolute;
          top: -1px;
          left: 0;
          height: 1px;
          background-color: ${e=>e.theme.colors.secondaryFont};
          width: calc(100% + 1px);
        }

        &:hover {
          background-color: ${e=>e.theme.colors.secondaryFont};
        }
      }
    }

    th,
    td {
      border: none;
      padding: 0;
    }
  }

  .DayPickerNavigation {
    display: flex;
    justify-content: space-between;
  }
`;function Zn({small:e}){let{formatMessage:t}=useLocales();return e?jsx(kc,{name:t(commonMessages.next),children:jsx(e$1,{name:"VMSWeb-chevron-right"})}):jsx(wc,{name:t(commonMessages.next),borderType:"none-round",icon:"VMSWeb-chevron-right"})}var wc=Ze(x)`
  margin-top: 10px;
  margin-right: ${e=>e.theme.spacing.m};
`,kc=Ze(E)`
  margin-top: 23px;
  margin-right: ${e=>e.theme.spacing.s};
`;function jn({small:e}){let{formatMessage:t}=useLocales();return e?jsx(Bc,{name:t(commonMessages.previous),children:jsx(e$1,{name:"VMSWeb-chevron-left"})}):jsx($c,{name:t(commonMessages.previous),borderType:"none-round",icon:"VMSWeb-chevron-left"})}var $c=Ze(x)`
  margin-top: 10px;
  margin-left: ${e=>e.theme.spacing.m};
`,Bc=Ze(E)`
  margin-top: 23px;
  margin-left: ${e=>e.theme.spacing.s};
`;function oi({onFocusChange:e,small:t,noBorder:o=!1,forceFocus:r=!1,onDateChange:n,isDayHighlighted:i,date:a,...s}){let[p,d]=Y.useState(!1),m=({focused:c})=>{d(c),e?.({focused:c});},f=c=>{n?.(c?.toDate()||null);};return jsxs(Fragment,{children:[jsx(Kn,{}),jsx(Lc,{small:t,noBorder:o,children:jsx(DayPickerSingleDateController,{...s,date:a?ko(a):null,onDateChange:f,isDayHighlighted:i?c=>i(c.toDate()):void 0,focused:r||p,onFocusChange:m,numberOfMonths:1,hideKeyboardShortcutsPanel:!0,navPrev:jsx(jn,{small:t}),navNext:jsx(Zn,{small:t}),daySize:t?24:40,noBorder:o,initialVisibleMonth:()=>a?ko(a):ko()},a?a.getTime():null)})]})}var Lc=Ze.div`
  ${e=>e.small&&css`
      .DayPicker {
        width: 184px !important;
        .CalendarDay {
          font-size: ${e.theme.fontSizes.xs};
          font-weight: 300;

          &__highlighted_calendar {
            font-weight: bold;
            &:not(.CalendarDay__selected):not(:hover) {
              background-color: ${e.theme.colors.primaryBackground};
            }
          }
        }
        .CalendarMonthGrid {
          left: 8px;
        }
        &_transitionContainer,
        &_focusRegion {
          width: 184px !important;
        }
        .CalendarMonth {
          padding: 0 !important;
          &_caption {
            font-size: ${e.theme.fontSizes.l};
            padding-top: ${e.theme.spacing.lm};
            padding-bottom: 28px;
          }
        }
        &_weekHeader {
          padding: 0 !important;
          top: 50px;
        }
      }
    `}

  ${e=>e.noBorder&&css`
      .DayPicker_focusRegion {
        box-shadow: none;
      }
    `}
`;var Ne=Ze(e)`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  @supports (-webkit-line-clamp: 2) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: initial;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
`;function ri({title:e,id:t,to:o}){let r=useLocation(),n=!!matchPath(r.pathname,{path:o,exact:!1,strict:!1,sensitive:!1});return jsx(R,{"data-test":t,to:o,children:jsx(Dc,{pl:"m",pr:"s",pb:"xs",pt:"xs",mb:"xxs",children:jsx(Ne,{color:"secondaryFont",textStyle:n?"body2Medium":"body2",children:e})})})}var Dc=Ze(a)`
  cursor: pointer;
  border-radius: 4px;

  &:hover {
    background-color: ${e=>e.theme.colors.secondaryBackground};
  }
`;function $t(e,t){let o=useLocation(),r=useMemo(()=>!!e.find(({to:n})=>!!matchPath(o.pathname,{path:n,exact:!1,strict:!1,sensitive:!1})),[e,o.pathname]);return useState(r?!1:t)}var ni='data:image/svg+xml,<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">%0A<rect width="14" height="14" rx="7" fill="white"/>%0A<path d="M7 9.635L10.09 11.5L9.27 7.985L12 5.62L8.405 5.31L7 2L5.595 5.31L2 5.62L4.725 7.985L3.91 11.5L7 9.635Z" fill="%23FEC636"/>%0A</svg>%0A';function li({items:e$2,title:t,to:o,id:r,premium:n,reload:i,collapsedState:a,setCollapsedState:s,exact:p}){let d=useLocation(),{formatMessage:m}=useLocales(),f=useMemo(()=>!!matchPath(d.pathname,{path:o?.split("?")[0]??"",exact:p??!1,strict:!1,sensitive:!1}),[o,p,d.pathname]),[c,b]=$t(e$2,!!a[r]),g=()=>{b(!c),s({...a,[r]:!c});};return jsxs(Fragment,{children:[(()=>{let h=jsxs(Zc,{mb:"xxs",pl:"s",pr:"xs",pt:"xs",pb:"xs",justifyContent:"space-between",alignItems:"center",onClick:g,active:f,children:[jsxs(k,{flexDirection:"row",children:[jsx(Ne,{textStyle:f?"body2Medium":"body2",color:f?"primaryNavigation":"secondaryFont",children:t}),n&&jsx("img",{src:ni,width:12,alt:"premium",style:{marginLeft:4}})]}),!he.isEmpty(e$2)&&jsx(E,{"aria-label":m(commonMessages.collapse),name:m(commonMessages.collapse),children:jsx(e,{fontSize:"l",children:jsx(e$1,{color:"primaryIcons",name:c?"VMSWeb-chevron-down":"VMSWeb-chevron-up"})})})]});return i?jsx(Qc,{"data-test":r,href:o,children:h}):jsx(R,{"data-test":r,to:o,children:h})})(),jsx(de,{collapsed:c,"data-test":`${r}-collapsible`,children:e$2.map(h=>h.allowed!==!1&&createElement(ri,{...h,key:h.id}))})]})}var Zc=Ze(k)`
  cursor: pointer;
  border-radius: 4px;

  ${e=>e.active?css`
          background-color: ${t=>t.theme.colors.margin};
        `:css`
          &:hover {
            background-color: ${t=>t.theme.colors.secondaryBackground};
          }
        `}
`,Qc=Ze.a`
  color: inherit !important;
  text-decoration: none !important;
`;function mi({title:e$2,items:t,id:o,collapsible:r=!0,collapsedState:n,setCollapsedState:i}){let{formatMessage:a$1}=useLocales(),[s,p]=$t(t,!!n[o]);return jsxs(Fragment,{children:[jsxs(om,{justifyContent:"space-between",alignItems:"center",onClick:r?()=>{p(!s),i({...n,[o]:!s});}:void 0,mb:"xs",pr:"xs",children:[jsx(Ne,{textStyle:"body2Medium",color:"primaryNavigation",children:e$2}),r&&jsx(E,{"aria-label":a$1(commonMessages.collapse),name:a$1(commonMessages.collapse),children:jsx(e,{fontSize:"l",children:jsx(e$1,{color:"primaryIcons",name:s?"VMSWeb-chevron-down":"VMSWeb-chevron-up"})})})]}),jsx(a,{mb:"s",children:jsx(de,{collapsed:s,"data-test":`${o}-collapsible`,children:t.map(m=>m.allowed!==!1&&createElement(li,{...m,key:m.id,collapsedState:n,setCollapsedState:i}))})})]})}var om=Ze(k)`
  cursor: pointer;
`;var VT=Ze.input`
  position: absolute;
  margin: 0;
  opacity: 0;
  padding: 0;
  cursor: pointer;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px);
  white-space: nowrap;
`;var gi=forwardRef(lm);function lm({"data-test":e,border:t,disabled:o,errorMessage:r,fieldHeight:n,fullWidth:i,textTransform:a,hideErrorMessage:s,invalid:p,name:d,onBlur:m,onFocus:f,prefix:c,suffix:b,value:g,...y},h){let[S,T]=useState(!1),C=useCallback(M=>{T(!1),m?.(M);},[m]),w=useCallback(M=>{T(!0),f?.(M);},[f]),$=e??d;return jsxs(n$1,{spacing:"xs",width:"100%","data-test":$?`${$}-container`:void 0,children:[jsxs(dm,{fullWidth:i,alignItems:"center",textTransform:a,disabled:o,border:t,isFocused:S,invalid:p,fieldHeight:n,children:[c&&jsx(cm,{children:c}),jsx("input",{...y,"data-test":$,name:d,value:g,ref:h,onFocus:w,onBlur:C,disabled:o}),b&&jsx(mm,{children:b})]}),!s&&jsx(Le,{children:r})]})}var dm=Ze(P)`
  ${e=>css`
    width: 100%;
    max-width: ${e.fullWidth?"100%":e.theme.sizes.fieldMaxWidth};
    background: ${e.theme.colors.inputBackground};
    padding: 0 ${e.fieldHeight==="xs"?e.theme.spacing.s:e.theme.spacing.m};
    border-radius: 4px;
    height: ${e.theme.fieldHeight[e.fieldHeight||"m"]};
    box-sizing: border-box;
    color: ${e.theme.colors.primaryFont};
    font: ${e.fieldHeight==="xs"?e.theme.textStyles.body2:e.theme.textStyles.body1};
    border: ${`1px solid ${e.theme.colors.borders}`};

    &:hover {
      border-color: ${e.disabled?e.theme.colors.borders:e.theme.colors.borderHover};
    }

    &:active {
      border-color: ${e.disabled?e.theme.colors.borders:e.theme.colors.borderFocus};
    }

    &::placeholder {
      color: ${e.theme.colors.secondaryFont};
    }
  `}

  ${e=>e.isFocused&&css`
      && {
        outline: none;
        border-color: ${e.theme.colors.borderFocus};

        ${e.disabled&&css`
          border-color: ${e.theme.colors.borders};
        `}
      }
    `}

  ${e=>e.disabled&&css`
      color: ${e.theme.colors.secondaryFont};
      background-color: ${e.theme.colors.secondaryBackground};
    `}

  ${e=>e.invalid&&css`
      border-color: ${e.theme.colors.error};
    `}

  ${e=>e.border&&css`
      border: ${e.border};
    `}

  & input {
    width: 100%;
    height: 100%;
    padding: 0;
    border: 0;
    box-sizing: border-box;
    background: inherit;
    color: inherit;
    outline: none;
    font-size: inherit;
    font-weight: inherit;

    ${e=>e.textTransform&&css`
        text-transform: ${e.textTransform};
      `}
  }
`,cm=Ze.div`
  padding-right: 4px;
`,mm=Ze.div`
  padding-left: 4px;
`;var Io=defineMessages({placeholder:{id:"sideNavigationSearch.placeholder",defaultMessage:"Search Settings..."},noResultLabel:{id:"sideNavigationSearch.noResultLabel",defaultMessage:"Nothing Found"}});function xi({items:e$1}){let t=useLocation(),o=useTheme(),{formatMessage:r}=useLocales(),n$1=useMemo(()=>Pm(e$1),[e$1]),i=useMemo(()=>Number.parseInt(o.sizes.sideNavWidth)-Number.parseInt(o.sizes.sideNavPadding)*2,[o.sizes.sideNavPadding,o.sizes.sideNavWidth]),{result:a,setFilter:s}=n({options:n$1,optionToString:hi}),{isOpen:p,setInputValue:d,inputValue:m,getMenuProps:f,getInputProps:c,getComboboxProps:b,highlightedIndex:g,getItemProps:y}=useCombobox({items:a,itemToString:hi,circularNavigation:!0,onInputValueChange:C=>{C.isOpen&&s(C.inputValue??"");},onIsOpenChange:C=>{C.isOpen||d("");},onSelectedItemChange:({selectedItem:C})=>{C?.to&&window.location.replace(C.to);}}),h=f({},{suppressRefError:!0}),S=({flipped:C})=>jsxs(ym,{width:i,flipped:C,...h,children:[a.map((w,$)=>jsx(Cm,{pt:"xs",pb:"xs",pr:"s",pl:w.items?"s":"m",highlighted:g===$,...y({item:w,index:$}),children:jsx(e,{textStyle:matchPath(t.pathname,w.to)?.isExact?"body2Medium":"body2",color:w.items?"primaryFont":"secondaryFont",children:w.title})},w.id)),a.length===0&&jsx(Sm,{children:r(Io.noResultLabel)})]}),T=useCallback(C=>jsx("div",{...b({ref:C.ref}),children:jsx(gi,{"data-test":"sr-side-navigation-search",fieldHeight:"xs",placeholder:r(Io.placeholder),...c({value:m})})}),[r,b,c,m]);return jsx(w,{show:p,content:S,alignment:"bottom",targetOffset:2,bodyOffset:0,useSmartAlignment:!0,children:T})}var ym=Ze(p)`
  border-radius: 4px;
  overflow-y: auto;
`,Sm=Ze(o)`
  font: ${e=>e.theme.textStyles.body2};
`,Cm=Ze(k)`
  background: ${e=>e.highlighted?e.theme.colors.margin:e.theme.colors.primaryBackground};
`,Pm=e=>{let t=[];return e.filter(o=>o.allowed!==!1).forEach(o=>{o.items.filter(r=>r.allowed!==!1).forEach(r=>{t=[...t,r,...r.items.filter(n=>n.allowed!==!1)];});}),t},hi=e=>{let t=e?.title??"";return e?.keywords&&(t=`${t} ${e.keywords.join(" ")}`),t};function yi({venue:e$1,user:t="",items:o,calendar:r,hideVenueName:n=!1,hideSearch:i=!1,...a}){let s=useTheme(),[p,d]=useState(!1),m=useRef(null),{y:f}=B({y:0,ref:m}),[c,b]=o$1({},`sideNavigationCollapsedState_${t}`);useEffect(()=>{d(f);},[f]);let g=s.sizes.sideNavPadding;return jsxs(Bm,{...a,children:[!n&&jsx(Im,{padding:g,children:jsx(e,{color:"secondaryFont",textTransform:"uppercase",fontWeight:"bold",children:he.unescape(e$1)})}),r&&jsx(P,{height:"251px",justifyContent:"center",children:jsx(oi,{date:r.date,onDateChange:y=>r?.onDateChange?.(y),isDayHighlighted:r.isDayHighlighted,forceFocus:!0,small:!0,noBorder:!0})}),!i&&jsx(Mm,{mt:"s",padding:g,lifted:p,children:jsx(xi,{items:o})}),jsx(Lm,{padding:g,lifted:p,ref:m,children:o.map(y=>y.allowed!==!1&&createElement(mi,{...y,key:y.id,collapsedState:c,setCollapsedState:b}))})]})}var Bm=Ze(n$1)`
  width: ${e=>e.theme.sizes.sideNavWidth};
  height: 100%;
  max-height: 100vh;
  top: 0;
  position: fixed;
  box-sizing: border-box;
  border-right: 1px solid ${e=>e.theme.colors.dividerLines};
  background: ${e=>e.theme.colors.primaryBackground};
  z-index: ${e=>e.theme.zIndex.navbar};
`,Im=Ze(a)`
  height: ${e=>e.theme.fieldHeight.m};
  margin-top: ${e=>e.theme.sizes.sideNavPadding};
  padding: 0 ${e=>e.padding};
  flex-shrink: 0;
`,Mm=Ze(a)`
  padding: 0 ${e=>e.padding} ${e=>e.theme.spacing.lm};
  ${e=>e.lifted&&css`
      box-shadow: ${e.theme.shadows.primary};
    `};
`,Lm=Ze(a)`
  overflow-y: auto;
  padding: 0 ${e=>e.padding} ${e=>e.theme.spacing.s};
  ${e=>e.lifted&&css`
      border-top: 1px solid ${e.theme.colors.dividerLines};
    `};
`;var Se=defineMessages({rowsPerPage:{id:"uikit.pagination.rowsPerPage",defaultMessage:"Rows per page:"},pagesCount:{id:"uikit.pagination.pagesCount",defaultMessage:"{start}-{end} of {total} items"},firstPage:{id:"uikit.pagination.firstPage",defaultMessage:"First page"},backPage:{id:"uikit.pagination.backPage",defaultMessage:"back"},nextPage:{id:"uikit.pagination.nextPage",defaultMessage:"Next"},lastPage:{id:"uikit.pagination.lastPage",defaultMessage:"Last page"}});var zm=[10,20,30,40],Dm=zm.map(e=>({id:e.toString(),label:e.toString()}));function Si(e$1){let{formatMessage:t}=useLocales(),o=e$1.options?.length?e$1.options:Dm,[r,n]=useState((o.find(s=>s.id===e$1.rowsPerPage.toString())??o[0]).id),i=typeof e$1.totalItemsCount=="number"?Math.min(e$1.rowsPerPage*e$1.currentPage,e$1.totalItemsCount):e$1.rowsPerPage*e$1.currentPage,a$1=s=>{n(s),e$1.onPerPageChange(parseInt(s));};return jsxs(k,{alignItems:"center",children:[jsx(a,{pr:"m",children:jsx(e,{children:t(Se.rowsPerPage)})}),jsx("div",{style:{width:90},children:jsx(We,{options:o,value:r,onChange:a$1,searchable:!1})}),jsx(a,{pl:"l",pr:"l",children:jsx(e,{children:t(Se.pagesCount,{start:e$1.rowsPerPage*e$1.currentPage-e$1.rowsPerPage+1,end:i,total:e$1.totalItemsCount})})}),jsx(x,{borderType:"none-round",icon:"VMSWeb-page-first","data-test":"ui-kit-pagination-first",onClick:()=>e$1.goToPage("first"),disabled:!e$1.canPreviousPage,title:t(Se.firstPage)}),jsx(x,{borderType:"none-round",icon:"VMSWeb-chevron-left","data-test":"ui-kit-pagination-prev",onClick:()=>e$1.goToPage("prev"),disabled:!e$1.canPreviousPage,title:t(Se.backPage)}),jsx(x,{borderType:"none-round",icon:"VMSWeb-chevron-right","data-test":"ui-kit-pagination-next",onClick:()=>e$1.goToPage("next"),disabled:!e$1.canNextPage,title:t(Se.nextPage)}),!e$1.hideLastPage&&jsx(x,{borderType:"none-round",icon:"VMSWeb-page-last","data-test":"ui-kit-pagination-last",onClick:()=>e$1.goToPage("last"),disabled:!e$1.canNextPage,title:t(Se.lastPage)})]})}function ak(e$1){return jsxs(yt,{gridTemplateColumns:"repeat(12, 1fr)",gap:"lm",gridAutoRows:"min-content",children:[jsx(a,{maxWidth:"100%",gridColumn:"auto / span 4",children:jsx(e,{fontSize:"m",children:e$1.left})}),jsx(a,{maxWidth:"100%",gridColumn:"auto / span 8",children:jsx(e,{fontSize:"m",textOverflow:e$1.textOverflow,children:e$1.right})})]})}function _m({primary:e$1,secondary:t,label:o,onClick:r}){return jsxs(n$1,{p:"lm",children:[jsx(M,{type:"h2",children:e$1}),jsx(a,{pt:"m",children:jsx(e,{children:t})}),o&&r&&jsx(k,{justifyContent:"flex-end",pt:"l",pb:"s",children:jsx(Pi,{"data-test":`sr-${o}-button`,variant:"secondary",size:"s",onClick:r,children:o})})]})}function Vm({primary:e,secondary:t,label:o,onClick:r}){return jsxs(P,{pt:"m",pb:"m",pl:"lm",pr:"lm",spacing:"3xl",children:[jsxs(n$1,{flexGrow:1,children:[jsx(M,{type:"h2",children:e}),jsx(a,{pt:"xs",children:jsx(j,{children:t})})]}),o&&r&&jsx(k,{alignItems:"center",children:jsx(Pi,{"data-test":`sr-${o}-button`,variant:"secondary",size:"s",onClick:r,children:o})})]})}function yk({size:e="l",...t}){return jsx(Um,{size:e,children:e==="s"?jsx(_m,{...t}):jsx(Vm,{...t})})}var Gm={xl:"968px",l:"920px",s:"448px"},Um=Ze(a)`
  max-width: ${e=>Gm[e.size]};
  background-color: ${e=>e.theme.colors.margin};
  border-radius: 10px;
  box-shadow: ${e=>e.theme.shadows.primary};
`,Pi=Ze(G)`
  background-color: ${e=>e.theme.colors.inputBackground};
`;function wk(e){return jsx(Xm,{children:jsx(Km,{children:e.children})})}var Xm=Ze.table`
  background: inherit;
  width: 100%;
  border: none;
  border-spacing: 0;
  border-collapse: separate;
`,Km=Ze.tbody`
  background: inherit;
`;function Lk(e$1){let{count:t$1,clearChildren:o}=t(e$1.children);return t$1===0?null:jsxs(Ym,{children:[jsx(qm,{firstColWidth:e$1.firstColWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:e$1.name})})}),Array.isArray(o)?o.map((r,n)=>jsx(Wo,{colWidth:e$1.colWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:r})})},n)):jsx(Wo,{colWidth:e$1.colWidth,children:jsx(a,{p:"xs",children:jsx(e,{children:o})})})]})}var Ym=Ze.tr``,Wo=Ze.td`
  border: none;
  padding: 0;
  border-bottom: 1px solid ${e=>e.theme.colors.dividerLines};
  width: ${e=>e.colWidth??"initial"};
  vertical-align: top;
`,qm=Ze(Wo)`
  width: ${e=>e.firstColWidth??"324px"};
`;function Dk(e$1){let{count:t$1,clearChildren:o}=t(e$1.children);return t$1===0?null:jsxs(Fragment,{children:[e$1.caption!==void 0&&jsx(Qm,{position:e$1.position,children:Array.isArray(e$1.caption)?e$1.caption.map((r,n)=>jsx(wi,{children:jsx(a,{p:"xs",children:jsx(e,{fontWeight:"bold",children:r})})},n)):jsx(wi,{colSpan:2,children:jsx(a,{p:"xs",children:jsx(e,{fontWeight:"bold",children:e$1.caption})})})}),o,jsx(Jm,{children:jsx(ki,{children:jsx(a,{p:"m"})})})]})}var Qm=Ze.tr`
  position: ${e=>e.position||"sticky"};
  top: 0;
  background: inherit;
`,ki=Ze.td`
  border: none;
  padding: 0;
`,wi=Ze(ki)`
  border-bottom: 2px solid ${e=>e.theme.colors.dividerLines};
`,Jm=Ze.tr`
  :last-child {
    display: none;
  }
`;function qk(e){return jsxs(tp,{children:[jsx(op,{pl:"m",pr:"m",pt:"s",pb:"s",children:jsx(M,{type:"h4",children:e.title})}),jsx(rp,{p:"m",children:e.children})]})}var Ho="4px",tp=Ze.div`
  background: ${e=>e.theme.colors.secondaryBackground};
  border-radius: ${Ho};
`,op=Ze(a)`
  background: ${e=>e.theme.colors.dividerLines};
  border-top-left-radius: ${Ho};
  border-top-right-radius: ${Ho};
`,rp=Ze(a)`
  background: inherit;
`;var[Ri,$i]=a$1();function Mi(e){let t=useTheme(),o=$i(),[r,n]=Y.useState([]),i=r.length>0,a=Y.useCallback(c=>{n(b=>[...b,c]);},[]),s=Y.useCallback(c=>{n(b=>b.filter(g=>g.key!==c.key));},[]),d=useTransition(r,{key:c=>c.key,config:{duration:150},from:{opacity:0,transform:"translateY(0px)",pointerEvents:"none"},enter:{opacity:1,transform:`translateY(${t.modal.topOffset}px)`,pointerEvents:"all"},leave:{opacity:0,transform:"translateY(0px)",pointerEvents:"none"},update:(c,b)=>({opacity:b===r.length-1?1:0,transform:`translateY(${b===r.length-1?t.modal.topOffset:0}px)`,pointerEvents:b===r.length-1?"all":"none"})})((c,b)=>o.dom&&jsx(cp,{ref:b.setNode,style:{transform:c.transform,opacity:c.opacity,pointerEvents:c.pointerEvents}},b.key)),m=Y.useMemo(()=>({register:a,unregister:s,hasOpenedItems:i}),[a,s,i]),f=Y.useCallback(()=>{r.at(-1)?.close();},[r]);return Y.useEffect(()=>{let c=b=>{b.code==="Escape"&&f();};return document.addEventListener("keydown",c),()=>{document.removeEventListener("keydown",c);}},[f,r]),jsxs(dp,{value:m,children:[o.dom&&Ii.createPortal(jsx(zr,{onClick:f,isActive:i,"data-test":"ui-kit-backdrop",children:d}),o.dom),e.children]})}var [dp,Li]=a$1(),cp=Ze(animated.div)`
  position: absolute;
  display: flex;
  will-change: transform, opacity, pointer-events;
  width: 100%;
  height: calc(100% - ${e=>e.theme.modal.topOffset*2}px);
`;var Sp={vx:vmsTheme,gx:gxTheme},Cp={vx:e$2,gx:h$1},Pp={vx:d,gx:g$1};function TR({children:e,theme:t,themeOverride:o,locale:r,messages:n}){let[i,a]=Y.useState(null),s=Y.useMemo(()=>({dom:i}),[i]),p=useMemo(()=>Cp[t](he.merge(Pp[t],o)),[t,o]);return jsx(LocaleRoot,{locale:r,messages:n,children:jsx(ThemeProvider,{theme:p,children:jsxs(ThemeProvider$1,{theme:Sp[t],children:[jsx(Normalize,{}),jsxs(Ri,{value:s,children:[jsx(Mi,{children:e}),jsx("div",{"data-test":"ui-kit-portal-root",ref:a})]}),jsx($n,{})]})})})}function LR(e){let t=useRef(null),[o,r]=useState(1);return useLayoutEffect(()=>{let n=1,i=t.current?.parentElement;i&&(e.scaleWidth&&!e.scaleHeight?(n=Math.min(t.current.parentElement.offsetWidth/t.current?.offsetWidth,1),e.updateSize&&(i.style.height=`${i.clientHeight*n}px`)):e.scaleHeight&&!e.scaleWidth?(n=Math.min(t.current.parentElement.offsetHeight/t.current?.offsetHeight,1),e.updateSize&&(i.style.width=`${i.clientWidth*n}px`)):(n=Math.min(t.current.parentElement.offsetWidth/t.current?.offsetWidth,t.current.parentElement.offsetHeight/t.current?.offsetHeight,1),e.updateSize&&(i.style.width=`${i.clientWidth*n}px`,i.style.height=`${i.clientHeight*n}px`)),r(n));},[t,e.scaleWidth,e.scaleHeight,e.updateSize]),jsx(a,{width:"100%",height:"100%",children:jsx(Rp,{scale:o,ref:t,children:e.children})})}var Rp=Ze(a)`
  width: fit-content;
  overflow: hidden;
  transform-origin: 0 0 0;
  transform: ${e=>`scale(${e.scale})`};
`;function Ni({type:e$1="h2",title:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,collapsed:i,...a$1}){let s=n?i:!1;return jsxs(Fragment,{children:[jsx(a,{mb:r?"xs":void 0,children:jsx(M,{type:e$1,...a$1,children:t})}),o&&jsx(a,{mt:"xs",mb:"xs",children:jsx(e,{fontSize:"m",children:o})}),r&&!s&&jsx(j,{children:r})]})}function Hi({title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,collapsed:a$1,onToggleCollapse:s,hasError:p,ml:d,mr:m,mb:f,mt:c}){let b=p$1("s");return jsxs(Fragment,{children:[jsxs(k,{width:"100%",justifyContent:"space-between",flexWrap:"wrap",children:[jsx(k,{flexBasis:"40%",flexGrow:1,flexShrink:1,minWidth:"100px",alignItems:r?void 0:"center",children:jsx(a,{children:jsx(Ni,{ml:d,mr:m,mb:f,mt:c,title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,collapsed:a$1})})}),jsxs(k,{flexGrow:0,flexShrink:0,alignItems:b?"center":"flex-start",children:[!b&&i,s&&jsx(a,{ml:d||i?"s":void 0,mt:c||"xs",mr:m,mb:f,children:jsx(K,{"aria-expanded":a$1?"false":"true",onClick:s?()=>s(!a$1):void 0,size:"s",collapsed:a$1,disabled:p,"data-test":"sectionContent-collapseButton"})})]})]}),b&&i&&jsx(k,{width:"100%",children:i})]})}function Et({title:e,type:t,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,contentWhenCollapsed:a$1,maxWidth:s,hasError:p,children:d,backgroundColor:m,padding:f="lm",ml:c,mr:b,mb:g,mt:y,borderWidth:h=1,"data-test":S,...T}){return jsxs(Lp,{maxWidth:s,"data-test":S,backgroundColor:m,borderWidth:h,children:[!!(e||r||o||i)&&jsx(a,{pr:f,pl:f,pt:f,children:jsx(Hi,{ml:c,mr:b,mb:g,mt:y,type:t,title:e,subCaption:o,description:r,hideDescriptionOnCollapse:n,actions:i,hasError:p,...T})}),T.collapsed&&(a$1?jsxs(Fragment,{children:[jsx(a,{pb:"sm"}),jsx(a,{pl:f,pr:f,children:jsx(Jr,{margin:"none"})}),a$1]}):jsx(a,{pb:f})),T.collapsed?null:jsx(de,{collapsed:T.collapsed,children:d})]})}var Lp=Ze.section`
  background: ${e=>e.backgroundColor?e.theme.colors[e.backgroundColor]:"white"};
  border-radius: 4px;
  max-width: ${({maxWidth:e})=>e??"968px"};
  border: ${e=>`${e.borderWidth}px solid ${e.theme.colors.dividerLines}`};
`;function Fp({behavior:e,localStoragePrefix:t}){let o=useMemo(()=>new Map,[]),r=useCallback(async n=>{let i=o.get(n)?.(),{collapsed:a,canCollapse:s,onToggleCollapse:p}=i??{};if(a||await s?.()){if(e==="one-section-at-one-time"){let d=Array.from(o.entries()).filter(([c])=>c!==n).map(([c,b])=>b()).filter(c=>!c.collapsed);if(!(await Promise.all(d.map(c=>c.canCollapse()))).every(c=>c))return !1;for(let c of d)c.onToggleCollapse(!0);}}else return !1;return p?.(!a),!0},[e,o]);return {sections:o,tryToggleSection:r,localStoragePrefix:t,behavior:e}}var [m$,zp]=Ep(Fp);function Ai(e,{canCollapse:t,onToggleCollapse:o,initiallyCollapsed:r}={}){let[n]=useState(e),{sections:i,tryToggleSection:a,localStoragePrefix:s,behavior:p}=zp(),d=useMemo(()=>{try{let g=Array.from(i.entries()).map(([y,h])=>h()).some(y=>!y.collapsed);return r||g&&p==="one-section-at-one-time"}catch(g){if(g instanceof TypeError){let y=new SyntaxError("Section must be used within a SectionController");throw y.stack=g.stack,y}else throw g}},[i,p,r]),[m,f]=o$1(d,s?`sectionCollapsedState_${s}_${n}`:void 0),c=b$1({canCollapse:t??(async()=>!0),onToggleCollapse:g=>{o?.(g),f(g);},collapsed:m});return useEffect(()=>{n!==e&&console.warn(`Section name changed! You may experience unexpected behavior. ${n} -> ${e}`);let g=c();return g.canCollapse().then(y=>{y||g.onToggleCollapse(!1);}),()=>{i.delete(e);}},[e,n,i,c]),i.set(e,c),{tryToggleCollapse:useCallback(()=>a(n),[a,n]),collapsed:m}}function u$({initiallyCollapsed:e,name:t,onToggleCollapse:o,canCollapse:r,...n}){let{collapsed:i,tryToggleCollapse:a}=Ai(t,{initiallyCollapsed:e,canCollapse:r,onToggleCollapse:o});return jsx(Et,{...n,collapsed:i,onToggleCollapse:a})}function S$({initiallyCollapsed:e,localStorageKey:t,...o}){let[r,n]=o$1(!!e,t?`simpleSectionCollapsedState_${t}`:void 0);return jsx(Et,{...o,collapsed:r,onToggleCollapse:()=>n(i=>!i)})}function E$({"data-test":e$1,...t}){return jsxs(a,{"data-test":e$1,children:[jsxs(a,{pb:"lm",children:[jsx(a,{pb:"s",children:jsx(M,{type:t.type,children:t.header})}),jsx(e,{color:"secondaryFont",children:t.description})]}),t.children]})}var O$=Ze(l)`
  background: linear-gradient(188deg, rgba(214, 169, 232, 0.5) 6.26%, rgba(119, 210, 249, 0.2) 95.58%);
`;var X$=Ze.div`
  padding-top: ${e=>e.paddingTop}px;
  width: 100%;
  height: 100%;
  background: ${e=>e.theme.colors.secondaryBackground};
`;function J$({calendar:e,children:t,hideSearch:o,hideVenueName:r,showSideNavigation:n,sideNavigationItems:i,userId:a,venueInternalDisplayName:s}){return jsxs(Fragment,{children:[n&&a&&jsx(yi,{venue:s??"",user:a??"",items:i??[],calendar:e,hideVenueName:r,hideSearch:o}),jsx(Up,{showSideNavigation:n,children:t})]})}var Up=Ze.main`
  margin-left: ${e=>e.showSideNavigation?e.theme.sizes.sideNavWidth:0};
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: ${e=>e.theme.colors.secondaryBackground};
  flex-grow: 1;

  ${e=>e.showSideNavigation&&css`
      width: 100%;
      max-width: calc(100% - 194px);
    `}
`;function p0({title:e$2,subtitle:t,description:o,draggable:r,actions:n,collapsible:i,defaultCollapsed:a$1,size:s="l",memoCollapseState:p,children:d,...m}){let[f,c]=o$1(!!a$1,p?`sectionCollapsedState_${p}`:void 0);return jsxs(Yp,{size:s,...m,children:[jsxs(qp,{pr:"s",pl:"s",pt:o?"s":"xs",pb:o?"s":"xs",alignItems:"center",children:[r&&jsx(a,{pl:"xs",pr:"xs",children:jsx(e$1,{name:"VMSWeb-drag",color:"deactivated"})}),jsxs(Zp,{pl:"s",pr:"sm",flexDirection:"column",justifyContent:"center",flex:"auto",children:[(e$2||t)&&jsxs(Vi,{children:[e$2&&jsx(e,{fontWeight:"bold",children:e$2}),e$2&&t&&jsx(e,{children:" - "}),t&&jsx(e,{children:t})]}),o&&jsx(Vi,{pt:"xs",children:jsx(j,{children:o})})]}),n&&jsx(A,{anchor:jsx(x,{borderType:"none-round",icon:"VMSWeb-more-vertical",size:"s","data-test":"settingsSection-menuButton"}),children:n}),i&&jsx(a,{ml:"s",children:jsx(K,{size:"s",collapsed:f,onToggle:c,"data-test":"settingsSection-collapseButton"})})]}),jsx(de,{collapsed:f,children:d})]})}var Yp=Ze.section`
  max-width: ${e=>e.size==="l"?"920px":"448px"};
`,qp=Ze(k)`
  background: ${e=>e.theme.colors.secondaryBackground};
  border-radius: 4px;
`,Zp=Ze(k)`
  width: 0;
  min-height: ${e=>e.theme.spacing.l};
  font-size: ${e=>e.theme.fontSizes.m};
`,Vi=Ze(a)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;function Jp({show:e,...t},o){return jsx(jp,{...t,ref:o,display:e?"flex":"none",backgroundColor:"overlayBackground",position:"absolute",overflow:"hidden"})}var S0=Y.forwardRef(Jp),jp=Ze(k)`
  transition: ${f.animation.duration.overlay} ease;
  gap: ${e=>e.theme.spacing.m};
  lex: none;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
`;function Ui({children:e,close:t}){return jsx(s,{children:o=>jsx(of,{zIndex:o,pr:"lm",pl:"lm",children:e?jsx(e.type,{...e.props,close:t}):null})})}var of=Ze(a)`
  display: flex;
  align-items: center;
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0px -2px 4px rgba(9, 34, 56, 0.1);
  height: 58px;
  width: 100%;
`;function Xi({title:e,onClose:t,showCloseButton:o=!0}){return jsx(s,{children:r=>jsxs(nf,{pl:"lm",pr:"sm",zIndex:r,children:[jsx(M,{type:"h2",children:e}),o&&jsx(x,{"data-test":"ui-kit-slideout-close",borderType:"none-round",icon:"VMSWeb-close",onClick:t,"aria-label":"Close"})]})})}var nf=Ze(a)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: ${e=>e.theme.colors.primaryBackground};
  box-shadow: 0 2px 4px rgba(9, 34, 56, 0.1);
  height: 58px;
  width: 100%;

  h2 {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

  button {
    flex-shrink: 0;
  }
`;function _0({show:e,title:t,background:o,noTopPadding:r,width:n=800,children:i,enableBackdrop:a=!1,enableFocusLock:s=!1,enableAutoFocus:p=!0,enableReturnFocus:d=!1,enableScrollLock:m=!1,handleFocusableElements:f=!1,footer:c=null,shouldCloseOnClick:b=!1,shouldCloseOnEscapePress:g=!0,showCloseButton:y=!0,onBeforeClose:h=he.noop,onCloseComplete:S=he.noop,onOpenComplete:T=he.noop,"data-test":C}){return jsx(Wn,{show:e,enableBackdrop:a,enableFocusLock:s,enableAutoFocus:p,enableReturnFocus:d,enableScrollLock:m,shouldCloseOnClick:b,shouldCloseOnEscapePress:g,onExited:S,onEntered:T,onBeforeClose:h,handleFocusableElements:f,children:({state:w,close:$})=>jsxs(lf,{"data-test":C,width:n,"data-state":w,children:[jsx(Xi,{title:t,onClose:$,showCloseButton:y}),jsx(sf,{noTopPadding:r,background:o,children:typeof i=="function"?i({close:$}):i}),jsx(Ui,{close:$,children:c})]})})}var sf=Ze.div`
  flex: 1;
  flex-basis: ${({width:e})=>typeof e=="string"?e:`${e}px`};
  overflow: auto;
  background: ${e=>e.theme.colors[e.background??"primaryBackground"]};
  padding: ${e=>`${e.theme.spacing.l} ${e.theme.spacing.lm}`};

  ${e=>e.noTopPadding&&css`
      padding-top: 0;
    `}
`,lf=Ze.div`
  position: absolute;
  left: auto;
  right: 0;
  height: 100vh;
  max-height: 100%;
  width: ${({width:e})=>typeof e=="string"?e:`${e}px`};
  max-width: 100vw;
  transform: translateX(100%);
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 8px rgba(9, 34, 56, 0.1);

  ${({theme:{animation:e}})=>css`
    &[data-state='entering'],
    &[data-state='entered'] {
      animation: ${df} ${e.duration.slideOut} ${e.easing.deceleration} both;
    }
    &[data-state='exiting'],
    &[data-state='exited'] {
      animation: ${cf} ${e.duration.slideOut} ${e.easing.acceleration} both;
    }
  `}
`,df=keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`,cf=keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`;function J0({title:e$1,description:t,actions:o,collapsible:r,collapsed:n,children:i,onClick:a$1,...s}){return jsxs(gf,{highlightOnHover:n&&!!a$1,...s,children:[!!(e$1||t||o||r)&&jsx(yt,{gridTemplateColumns:"repeat(12, 1fr)",gap:"lm",gridAutoRows:"min-content",children:jsx(Kr,{maxWidth:"100%",gridColumn:"auto / span 12","data-test":"ui-kit-slideout-subsection-clickable",onClick:a$1,children:jsx(a,{pr:"lm",pl:"lm",pt:"m",children:jsxs(k,{flexDirection:"column",children:[jsx(a,{children:jsxs(k,{justifyContent:"space-between",alignItems:"center",children:[jsx(a,{children:jsx(M,{type:"h3",children:e$1})}),jsx(k,{children:o})]})}),jsx(a,{children:jsx(e,{children:t})})]})})})}),i]})}var gf=Ze.section`
  background: white;
  border-radius: 10px;
  max-width: 752px;
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  overflow: hidden;
  ${e=>e.height&&`height: ${e.height};`}
  ${e=>e.highlightOnHover&&css`
      &:hover {
        border: 1px solid ${e.theme.colors.secondaryFont};
      }
    `}
`;var Zi=Ze.table`
  height: 1px;
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  border-style: hidden;
  box-sizing: border-box;
  margin-bottom: 0;

  th,
  td {
    border: none;
    padding: 0;
  }
`;var Qi=Ze.tbody``;function Dt(e$1){return jsx(bf,{as:e$1.isHeader?"th":void 0,...e$1,children:jsx(q,{...e$1,children:jsx(xf,{...e$1,children:jsx(e,{fontSize:"m",type:"div",width:"100%",fontWeight:e$1.isHeader?"bold":void 0,textDisplay:e$1.textDisplay,justifyContent:e$1.justifyContent,textAlign:e$1.textAlign,children:e$1.children})})})})}var xf=Ze.div`
  display: ${e=>e.displayBlock?"block":"flex"};
  padding: 19px ${e=>`${e.theme.spacing.m}`};
  height: 100%;
  width: 100%;
  align-items: ${e=>e.alignItems??"center"};
  box-sizing: border-box;

  justify-content: ${e=>{switch(e.justifyContent){case void 0:case"center":return e.justifyContent;default:return `flex-${e.justifyContent}`}}};

  ${e=>e.removeRightPadding&&css`
      padding-right: 0;
    `}

  ${e=>e.backgroundColor&&css`
      background-color: ${e.theme.colors[e.backgroundColor]};
    `}

  ${e=>e.removeLeftPadding&&css`
      padding-left: 0;
    `}

  ${e=>e.shouldAddNestingPadding&&css`
      padding-left: ${e.theme.spacing.l};
    `}

    ${e=>e.removePadding&&css`
      padding: 0;
    `}
`,q=Ze.div`
  min-height: 54px;
  border-bottom: ${e=>e.noBorderBottom?"none":`1px solid ${e.theme.colors.borders}`};
  border-left: ${e=>e.borderLeft?`1px solid ${e.theme.colors.borders}`:"none"};
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;

  ${e=>e.isHeader&&css`
      white-space: nowrap;
      height: 100%;
      border-top: ${e.noTopBorder?"none":`1px solid ${e.theme.colors.borders}`};
    `};
`,bf=Ze.td`
  background: ${e=>e.isNested?e.theme.colors.secondaryBackground:"white"};
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  ${e=>e.isHeader&&css`
      text-align: ${e.headerAlign||"left"};
    `};

  ${e=>e.attach==="left"&&css`
      position: sticky;
      left: 0;
      z-index: ${e.isHeader?1:0};

      & > ${q} {
        box-shadow: ${e.noBoxShadow?"none":`2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `};

  ${e=>e.isHeader&&css`
      position: sticky;
      top: 0;
      z-index: ${e.attach===void 0?0:1};

      ${q} {
        box-shadow: ${e.noBoxShadow?"none":`2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `}

  ${e=>e.attach==="right"&&css`
      position: sticky;
      right: 0;
      z-index: ${e.isHeader?1:0};

      & > ${q} {
        box-shadow: ${e.noBoxShadow?"none":`-2px 0px 3px ${e.theme.shadows.primaryColor}`};
      }
    `};

  &:first-child > ${q} {
    border-left: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  }

  &:last-child > ${q} {
    border-right: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  }

  ${e=>e.isInFirstRow&&css`
      &:first-child > ${q} {
        border-top-left-radius: ${t=>t.theme.table.borderRadius};
      }

      &:last-child > ${q} {
        border-top-right-radius: ${t=>t.theme.table.borderRadius};
      }
    `};

  ${e=>e.isInLastRow&&css`
      &:first-child > ${q} {
        border-bottom-left-radius: ${t=>t.theme.table.borderRadius};
      }

      &:last-child > ${q} {
        border-bottom-right-radius: ${t=>t.theme.table.borderRadius};
      }
    `};

  ${({width:e})=>e&&css`
      width: ${typeof e=="string"?e:`${e}px`};
    `}

  ${({minWidth:e})=>e&&css`
      min-width: ${typeof e=="string"?e:`${e}px`};
    `}

  ${({maxWidth:e})=>e&&css`
      max-width: ${typeof e=="string"?e:`${e}px`};
    `}
`;var uB=Ze.tfoot``;var bB=Ze.thead``;var ji=Ze.tr`
  ${e=>e.hoverOnRows&&css`
      &:hover td {
        cursor: pointer;
        background: ${t=>t.theme.colors.secondaryBackground};
      }
    `}

  ${e=>e.isSelected&&css`
      && {
        td {
          background: ${t=>t.theme.colors.margin};
        }
      }
    `}
`;function ta(e){let{formatMessage:t}=useLocales();return jsx(Fragment,{children:e.row.canExpand?jsxs(k,{alignItems:"center",onClick:o=>{o.stopPropagation();},children:[e.value,jsx(a,{p:"s",children:jsx(x,{"data-test":"ui-kit-spreadsheet-expand-cell",...e.row.getToggleRowExpandedProps({}),title:t(e.row.isExpanded?commonMessages.collapse:commonMessages.expand),borderType:"none-round",icon:e.row.isExpanded?"VMSWeb-chevron-down":"VMSWeb-chevron-right"})})]}):e.value})}function oa(e){let t=Y__default.useCallback(o=>{switch(o){case"first":return e.table.gotoPage(0);case"prev":return e.table.previousPage();case"next":return e.table.nextPage();case"last":return e.table.gotoPage(e.table.pageCount-1);default:return e.table.gotoPage(o)}},[e.table]);return jsx(k,{justifyContent:"flex-end",children:jsxs(kf,{children:[jsx(Rf,{noBorder:e.noBorder}),jsx($f,{noBorder:e.noBorder,children:jsx(Si,{currentPage:e.table.state.pageIndex+1,totalItemsCount:e.totalItemsCount,rowsPerPage:e.table.state.pageSize,canPreviousPage:e.table.canPreviousPage,canNextPage:e.table.canNextPage,onPerPageChange:e.table.setPageSize,goToPage:t})})]})})}var kf=Ze.div`
  background: ${e=>e.theme.colors.primaryBackground};
  width: 100%;
  display: inline-flex;
  justify-content: flex-end;
  border-top: 1px solid ${e=>e.theme.colors.borders};
`,Rf=Ze.div`
  position: sticky;
  width: 100%;
  left: 0;
  margin-right: auto;
  border-bottom: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-left: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-bottom-left-radius: ${e=>e.theme.table.borderRadius};
`,$f=Ze.div`
  position: sticky;
  min-width: max-content;
  right: 0;
  padding: ${e=>`${e.theme.spacing.m} ${e.theme.spacing.lm}`};
  border-bottom: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-right: ${e=>e.noBorder?"none":`1px solid ${e.theme.colors.borders}`};
  border-bottom-right-radius: ${e=>e.theme.table.borderRadius};
`;function na({pin:e,...t}){let o=useRef(null);useEffect(()=>{let n=he.debounce(()=>{let i=document.querySelector("html");if(o.current&&i&&e){let a=e?e.getBoundingClientRect().bottom:0;if(i.scrollTop>=o.current.offsetTop-a){let s=i.scrollTop-o.current.offsetTop+a;o.current.setAttribute("style",`transition:0s; transform: translate3d(0px, ${s}px, 0px);`);}else o.current.setAttribute("style","transition:0s; transform: translate3d(0px, 0px, 0px);");}},200);return e&&window.addEventListener("scroll",n),()=>{window.removeEventListener("scroll",n);}},[e]);function r(n,i){let a=n;return typeof a.spreadsheetColumn.header=="string"&&a.spreadsheetColumn.header.length?{"data-test":`ui-kit-spreadsheet-${i}-${a.spreadsheetColumn.header}`}:{}}return jsx(Ef,{ref:o,children:t.headerGroups.map(n=>jsx("tr",{...n.getHeaderGroupProps(),children:n.headers.map(i=>jsxs(Dt,{...i.getHeaderProps(i.getSortByToggleProps()),isHeader:!0,isInFirstRow:!t.hideTopCorners,noBoxShadow:t.noBoxShadow,textDisplay:i.spreadsheetColumn.textDisplay,justifyContent:i.spreadsheetColumn.headerAlign??"center",attach:i.spreadsheetColumn.attach,width:i.spreadsheetColumn.width,minWidth:i.spreadsheetColumn.minWidth,maxWidth:i.spreadsheetColumn.maxWidth,backgroundColor:i.spreadsheetColumn.backgroundColor,removePadding:i.spreadsheetColumn.removePadding,noTopBorder:t.noBorder,noBorder:t.noBorder,...r(i,"header"),children:[i.render("Header"),i.isSorted?jsxs("span",{...r(i,"header-sort-arrow"),children:[jsx("span",{children:" "}),jsx(e$1,{name:i.isSortedDesc?"VMSWeb-arrow-down":"VMSWeb-arrow-up"})]}):""]}))}))})}var Ef=Ze.thead`
  position: relative;
  z-index: 1;
`;var rI=forwardRef(Gf);function Gf(e,t){let o=typeof e.data=="function",r=u(),[n,i]=useState(!1),a=useRef(null),s=useRef(null);useImperativeHandle(t,()=>({deselectAll:()=>{g.toggleAllRowsSelected(!1);}}));let p=useCallback(h=>typeof h=="function"?{data:[],pagination:{pageCount:-1,totalItemsCount:-1}}:{data:h,pagination:{pageCount:-1,totalItemsCount:h.length}},[]),d=useMemo(()=>p(e.data),[p,e.data]),[m,f]=Y__default.useState(()=>d),c=useMemo(()=>o?m:d,[d,o,m]),b=Y__default.useMemo(()=>e.columns.map(h=>{let S={Header:h.header,accessor:h.render,id:"key"in h?h.key:void 0,spreadsheetColumn:h,disableSortBy:!h.sortable,...h.sortType&&{sortType:h.sortType}};return h.expandable&&(S.id="expander",S.Cell=ta),S}),[e.columns]),g=useTable({data:c.data,columns:b,manualPagination:o,manualSortBy:o,pageCount:c.pagination.pageCount,disableSortBy:e.disableSortBy,initialState:{...e.sorted&&{sortBy:e.sorted},...e.initialPageSize&&{pageSize:e.initialPageSize}},autoResetExpanded:e.autoResetExpanded||!1},useSortBy,useExpanded,usePagination,useRowSelect),y=e.noPagination?g.rows:g.page;return Y__default.useEffect(()=>{e.onChange?.(g.state),typeof e.data=="function"&&e.data(g.state).then(h=>{f(h);});},[g.state.pageIndex,g.state.pageSize,g.state.sortBy,e.onChange]),Y__default.useEffect(()=>{let h=s.current;h&&i(h.clientWidth<h.scrollWidth);},[r]),Y__default.useEffect(()=>{e.onSortedChange?.(g.state.sortBy);},[e.onSortedChange,g.state.sortBy]),jsxs(Xf,{width:e.width,height:e.height,maxHeight:e.maxHeight,ref:a,children:[e.filterPanel,jsxs(Kf,{isVerticalScrollBlocked:e.isVerticalScrollBlocked,children:[jsx(Yf,{...g.getTableProps(),ref:s,children:jsxs(Zi,{children:[jsx(na,{headerGroups:g.headerGroups,noBoxShadow:!n,hideTopCorners:!!e.filterPanel||e.noBorder,noBorder:e.noBorder,pin:e.pin}),!e.placeholder&&jsx(Qi,{...g.getTableBodyProps(),children:y.map((h,S,T)=>{g.prepareRow(h);let C=S===T.length-1,w=e.renderPreComponent&&e.renderPreComponent({row:h,index:S,rows:y,containerWidth:`${a?.current?.clientWidth}px`}),$=e.renderPostComponent&&e.renderPostComponent({row:h,index:S,rows:y,containerWidth:`${a?.current?.clientWidth}px`});return jsxs(Y__default.Fragment,{children:[w&&jsx("tr",{children:jsx("td",{width:"100%",colSpan:100,children:w})}),jsx(ji,{...h.getRowProps(),isSelected:h.isSelected,hoverOnRows:e.hoverOnRows,onClick:()=>{e.onRowClick&&(g.toggleAllRowsSelected(!1),g.toggleRowSelected(h.id,!0),e.onRowClick(h.original));},children:h.cells.map((M,ne)=>{let k=M.column.spreadsheetColumn;return jsx(Dt,{...M.getCellProps(),isNested:h.depth>0,isInLastRow:e.noPagination&&C,removeRightPadding:h.canExpand,shouldAddNestingPadding:h.depth>0&&ne===0,noBorderBottom:!e.noPagination&&C,noBoxShadow:!n,attach:k.attach,width:k.width,minWidth:k.minWidth,maxWidth:k.maxWidth,justifyContent:k.cellAlign??"start",textAlign:k.cellAlign??"start",noBorder:e.noBorder,alignItems:k.alignItems,backgroundColor:k.backgroundColor,removePadding:k.removePadding,children:M.render("Cell")})})}),$&&jsx("tr",{children:jsx("td",{width:"100%",colSpan:100,children:$})})]},h.id)})}),!e.noPagination&&jsx("tfoot",{children:jsx("tr",{children:jsx(qf,{colSpan:b.length,children:jsx(oa,{table:g,totalItemsCount:c.pagination.totalItemsCount,noBorder:e.noBorder})})})})]})}),jsx(Uf,{children:e.placeholder})]})]})}var Uf=Ze.div`
  position: sticky;
  left: 0;
  width: 100%;
`,Xf=Ze.div`
  ${e=>e.width&&css`
      width: ${typeof e.width=="string"?e.width:`${e.width}px`};
    `}

  ${e=>e.height&&css`
      height: ${typeof e.height=="string"?e.height:`${e.height}px`};
    `}

  ${e=>e.maxHeight&&css`
      max-height: ${typeof e.maxHeight=="string"?e.maxHeight:`${e.maxHeight}px`};
    `}
`,Kf=Ze.div`
  width: 100%;
  height: 100%;
  max-height: inherit;
  overflow-y: ${e=>e.isVerticalScrollBlocked?"hidden":"auto"};
`,Yf=Ze.div`
  width: 100%;
  height: 100%;
  display: flex;
`,qf=Ze.td`
  position: sticky;
  bottom: 0;
  padding: 0;
`;function lI({primary:e$1,secondary:t,...o}){return jsxs(Qf,{...o,twoLineEllipsis:t===void 0,children:[jsx(e,{children:e$1}),jsx("br",{}),jsx(e,{color:"secondaryFont",children:t})]})}var sa=(e,t)=>e==="number"||typeof t=="number"?(e||0)>(t||0)?1:-1:(e||"").toLowerCase()>(t||"").toLowerCase()?1:-1,dI=(e,t,o)=>{let r=e.values[o]?.props,n=t.values[o]?.props,i=r.primary,a=n.primary;return i!==a?sa(i,a):sa(r.secondary,n.secondary)},Qf=Ze.div`
  box-sizing: content-box;
  min-height: 36px;

  ${e=>e.twoLineEllipsis?h:f$1}
`;function hI({title:e$1,description:t,image:o,alt:r,pt:n="xl",pb:i="xl"}){return jsxs(eg,{width:"100%",pt:n,pb:i,alignItems:"center",children:[o&&jsx(a,{mb:"l",children:jsx("img",{src:o,alt:r})}),e$1&&jsx(a,{children:jsx(e,{fontWeight:"bold",fontSize:"l",children:e$1})}),t&&jsx(a,{mt:"s",children:jsx(e,{color:"secondaryFont",children:t})})]})}var eg=Ze(n$1)`
  background: ${e=>e.theme.colors.primaryBackground};
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  border-top: none;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
`;function CI({children:e,...t}){return jsx(rg,{width:"100%",p:"m",spacing:"m",flexWrap:"wrap",...t,children:e})}var rg=Ze(P)`
  background: ${e=>e.theme.colors.primaryBackground};
  border: 1px solid ${e=>e.theme.colors.borders};
  border-bottom: 0;
  border-top-left-radius: ${e=>e.theme.table.borderRadius};
  border-top-right-radius: ${e=>e.theme.table.borderRadius};
`;function RI({children:e$1,width:t}){return jsx(ig,{children:jsx(ag,{width:t,pt:"s",pb:"s",pl:"m",pr:"m",children:jsx(e,{textTransform:"uppercase",color:"secondaryFont",fontSize:"s",children:e$1})})})}var ig=Ze.div`
  background-color: ${e=>e.theme.colors.dividerLines};
  width: 100%;
`,ag=Ze(a)`
  background-color: ${e=>e.theme.colors.dividerLines};
  box-sizing: border-box;
  max-width: ${e=>e.width};
  min-width: ${e=>e.width};
  border: ${e=>`1px solid ${e.theme.colors.borders}`};
  border-top: none;
  position: sticky;
  left: 0;
`;function OI(e){return jsx(lg,{...e,selectedTabClassName:"selected",selectedTabPanelClassName:"selected"})}var lg=Ze(fe.Tabs)`
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  line-height: ${e=>e.theme.lineHeights.s};
`,Pe=Ze(fe.Tab)`
  position: relative;
  padding: 11px 0;
  font-family: ${e=>e.theme.fonts.primary};
  font-size: ${e=>e.theme.fontSizes.m};
  line-height: ${e=>e.theme.lineHeights.s};
  user-select: none;
  cursor: default;
  list-style: none;

  &.selected {
    font-weight: 700;
    &::after {
      content: ' ';
    }
  }

  &:focus {
    outline: none;
  }

  &::before {
    content: ' ';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
  }

  &::after {
    display: block;
    position: absolute;
    height: 2px;
    bottom: 0;
    left: 0;
    right: 0;
    transform: translateY(2px);
    background: ${e=>e.theme.colors.primaryFont};
  }

  &::marker {
    display: none;
  }
`;Pe.tabsRole="Tab";var dg=Ze(fe.TabList)`
  width: max-content;
  list-style-type: none;
  margin: 0;
  padding: 0;
  display: flex;
  border-bottom: 2px solid ${e=>e.theme.colors.borders};

  ${e=>css`
    ${Pe} + ${Pe} {
      margin-left: ${e.theme.spacing.l};
    }

    ${Pe}:first-child {
      &::before {
        margin-right: -${e.theme.spacing.m};
      }
    }

    ${Pe}:last-child {
      &::before {
        margin-left: -${e.theme.spacing.m};
      }
    }

    ${Pe} + ${Pe}:not(:last-child) {
      &::before {
        margin: 0 -${e.theme.spacing.m};
      }
    }
  `}
`;dg.tabsRole="TabList";var cg=Ze(fe.TabPanel)`
  display: none;

  &.selected {
    display: block;
  }
`;cg.tabsRole="TabPanel";function da({options:e,value:t,onChange:o,disabled:r,backgroundColor:n="primaryBackground",...i}){let a=g(n,"lightFont","darkFont")==="lightFont",s=p$1("s"),p=p$1("xs"),d=useMemo(()=>{if(!s)return;let f=e.find(c=>c.id===t);if(f)return ug(f.id)},[s,e,t]),m="desktop";return p?m="tiny":s&&(m="mobile"),jsx(hg,{backgroundColor:n,disabled:r,isLightTheme:a,languagePickerWidth:m,children:jsx(We,{options:e,onChange:o,value:t,displayValue:d,searchable:!1,hideFilterIcon:p,disabled:r,withNativeSupport:!0,filterIcon:jsx(e$1,{name:"GX-language","data-test":"language-picker-icon"}),"data-test":"language-picker",...i})})}var ug=e=>{switch(e){case"zh_CN":return "\u7B80\u4F53";case"zh_HK":return "\u7E41\u9AD4";case"ja":return "\u65E5\u672C\u8A9E";case"th":return "\u0E44\u0E17\u0E22";default:return e.toUpperCase()}},hg=Ze(a)`
  width: ${e=>e.theme.topNav.languagePickerWidth[e.languagePickerWidth]};
  ${ea} {
    --border-color: ${e=>e.theme.colors.secondaryFont};
    background: ${e=>e.theme.colors[e.backgroundColor]};
  }
  ${e=>e.isLightTheme&&css`
      ${ea} {
        border-color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }

      ${$} {
        color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }

      ${f$2} {
        color: ${e.disabled?e.theme.colors.inactive:e.theme.colors.lightFont};
      }
    `}

  @media (max-width: ${e=>e.theme.breakpoints.s}px) {
    ${ho} {
      padding: ${e=>`${e.theme.spacing.sm} ${e.theme.spacing.s} ${e.theme.spacing.sm} ${e.theme.spacing.s}`};
    }
    ${$}, ${aa} {
      padding: 11px 0 11px 44px;
    }
    ${ca} {
      > i {
        margin: 0 14px;
      }
    }
  }

  @media (max-width: ${e=>e.theme.breakpoints.xs}px) {
    ${$}, ${aa} {
      padding: 11px 0 11px 16px;
    }
  }
`;function ma({active:e,setIsActive:t,closeable:o,children:r}){let n=useNavigation(),i=useSurfaceScope(),a=Li(),s=Y.useMemo(()=>Math.random().toString(),[]),p=Y.useCallback(()=>{o&&i?.destination.parent&&n.push(i.destination.parent,{from:i.destination}),t?.(!1);},[n,o,t,i?.destination]),[d,m]=Y.useState(null),f=Y.useMemo(()=>({key:s,setNode:m,close:p}),[p,s]),c=e??n.matchParams(i?.destination)!==void 0;return Y.useLayoutEffect(()=>(c&&a.register(f),()=>{a.unregister(f);}),[c]),d&&Ii.createPortal(r,d)}var wg=e=>/.+?-app\.qa\.sevenrooms\.com/g.test(e)?"https://staging-app.qa.sevenrooms.com":e.includes("eu.")?"https://www.sevenrooms.com":`https://${e}`,pa=wg(window.location.host),kg=`${pa}/app/global-client`;function fa({onLogin:e,onUpdate:t,onDelete:o,onCreate:r,onClose:n,onLoad:i,isProfilePage:a=!1}){let s=useRef(null),p=useCallback(d=>{let m=readIFrameMessage(d,pa);if(m)switch(m.topic){case"create":r(Qo(m.data.userInfo));break;case"error":break;case"login":e(Qo(m.data.userInfo));break;case"update":t(Qo(m.data.userInfo));break;case"delete":o();break;case"resize":if(!s.current)break;s.current.width=m.data.width,s.current.height=m.data.height;break;case"close":n();break;case"open":i();break;}},[e,t,o,r,n,i]);return useEffect(()=>(window.addEventListener("message",p),()=>{window.removeEventListener("message",p);}),[p]),jsx(Bg,{title:"sevenrooms-login",src:`${kg}${a?"/profile":""}`,height:"245px",ref:s})}var Qo=({id:e,emailAddress:t,firstName:o,lastName:r,phoneNumber:n})=>{let{phoneCountryCode:i,phoneDialCode:a}=Rg(n);return {clientId:e,firstName:o,lastName:r,emailAddress:t,phoneNumber:n,phoneDialCode:a,phoneCountryCode:i}},Rg=e=>{let t=parsePhoneNumber(e,{extract:!0});return {phoneCountryCode:$g(t?.country),phoneDialCode:t?.countryCallingCode}},$g=e=>e?.toLowerCase(),Bg=Ze.iframe`
  max-width: 100%;
  max-height: 100%;
  border: 0;
  @media (min-width: 535px) {
    width: 530px;
  }
  @media (max-width: 530px) {
    width: 100%;
  }
`;function xa({firstName:e$1,lastName:t,image:o,onLogout:r,onProfileClick:n,dataTest:i}){let{formatMessage:a}=useLocales(),[s,p]=Y__default.useState(null),d=!!s,m=c=>{p(c.currentTarget);},f=()=>{p(null);};return jsxs(Fragment,{children:[jsx(IconButton,{"data-test":i,sx:{padding:"3px"},size:"small",onClick:m,"aria-controls":d?"user-profile":void 0,"aria-haspopup":"true","aria-expanded":d?"true":void 0,children:jsx(Avatar,{sx:{width:36,height:36},src:o,children:`${e$1[0]}${t[0]}`.toUpperCase()})}),jsxs(Menu,{transformOrigin:{horizontal:"right",vertical:"top"},anchorOrigin:{horizontal:"right",vertical:"bottom"},anchorEl:s,id:"user-profile",open:d,onClose:f,onClick:f,children:[jsx(MenuItem,{onClick:n,children:jsx(e,{children:a(gflMessages.resWidgetProfileLink)})},"profile"),jsx(MenuItem,{onClick:r,children:jsx(e,{children:a(gflMessages.resWidgetLogoutLink)})},"logout")]})]})}function ya({backgroundColor:e="venueColor",onLogin:t,onUpdate:o,onLogout:r,onDelete:n,...i}){let[a,s]=useState(!1),[p,d]=useState(!1),m=useCallback(h=>{s(!1),t?.(h);},[t]),f=useCallback(h=>{s(!1),o?.(h);},[o]),c=useCallback(()=>{s(!1);},[]),b=useCallback(()=>{d(!0);},[]),g$1=g(e,"lightFont","secondaryFont"),y=`rgba(${g$1==="lightFont"?"255, 255, 255":"0, 0, 0"}, 0.4)`;return jsxs(Fragment,{children:[jsx(k,{alignSelf:"center",height:"100%",justifyContent:"flex-end",width:i.fullWidth?"100%":"auto",children:jsx(_g,{onLogout:r,onUpdate:o,backgroundColor:e,fontAndBorderColor:g$1,outlineColor:y,setIsModalOpen:s,...i})}),jsx(ma,{active:a,setIsActive:s,children:jsxs(vt,{ariaLabel:"login-modal",width:"fit-content",maxWidth:"100%",children:[!p&&jsx(Tt,{onClose:c}),jsx(Pn,{overflow:"visible",width:"100%",pr:"none",pl:"none",pt:"sm",pb:"lm",children:jsx(fa,{onLogin:m,onUpdate:f,onDelete:n,onCreate:m,onClose:c,onLoad:b,isProfilePage:!!i.userFirstName&&!!i.userLastName})})]})})]})}function _g({isLoading:e,userFirstName:t,userLastName:o,userImage:r,onLogout:n,setIsModalOpen:i,backgroundColor:a,fontAndBorderColor:s,outlineColor:p,disabled:d,fullWidth:m,size:f}){let{formatMessage:c}=useLocales(),b=useCallback(()=>{i(!0);},[i]);return e?jsx(SevenRoomsProgress,{"aria-label":"In Progress"}):t&&o?jsx(xa,{firstName:t,lastName:o,image:r,onLogout:n,onProfileClick:b,dataTest:"sr_avatar"}):jsxs(Gg,{"data-test":"sr-login-button",backgroundColor:a,fontAndBorderColor:s,outlineColor:p,borderRadius:"s",onClick:b,disabled:d,fullWidth:m,size:f,children:[jsx(SevenRoomsIcon,{sx:{marginRight:"8px"}}),c(gflMessages.resWidgetLogInButton)]})}var Vg="100px",Gg=Ze(G)`
  width: ${e=>e.fullWidth?"100%":Vg};
  background-color: ${e=>e.theme.colors[e.backgroundColor]};
  color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
  border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
  border-radius: ${e=>e.theme.borderRadius.s};

  &:focus:not(:focus-visible) {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
  }

  &:focus,
  &:hover {
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
  }

  &:focus {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    outline-offset: ${e=>e.theme.borderWidth.m};
  }

  &:focus-visible {
    ${e=>`outline: ${e.theme.borderWidth.l} solid ${e.outlineColor};`}
    outline-offset: ${e=>e.theme.borderWidth.m};
    color: ${e=>e.theme.colors[e.fontAndBorderColor]} !important;
    background-color: ${e=>e.theme.colors[e.backgroundColor]};
    border-color: ${e=>e.theme.colors[e.fontAndBorderColor]};
  }

  &:hover {
    font: ${e=>e.theme.textStyles.body1Bold};
    ${e=>`border: ${e.theme.borderWidth.l} solid ${e.theme.colors[e.fontAndBorderColor]};`}
  }
`;function Y1({baseUrl:e,logo:t,logoLabel:o,languagePicker:r,grow:n=!1,sevenRoomsLogin:i}){let a$1=p$1("m"),s=p$1("s"),p=p$1("xs"),{topNav:d,colors:{venueColor:m,primaryBackground:f}}=useTheme(),c=a$1?"m":"lm",b="desktop";return p?b="tiny":s&&(b="mobile"),jsxs(n$1,{"data-test":"top-nav",width:"100%",backgroundColor:"venueColor",borderBottomColor:m.toLocaleLowerCase()===f.toLocaleLowerCase()?"borders":"venueColor",justifyContent:r?"space-between":"center",zIndex:"default",position:"sticky",top:"none",children:[jsxs(P,{p:`sm ${c}`,height:a$1?d.height.mobile:d.height.desktop,justifyContent:"space-between",alignItems:"flex-start",children:[jsx(a,{width:"33%",minWidth:d.languagePickerWidth[b],children:r&&jsx(da,{...r,backgroundColor:"venueColor"})}),jsx(Kg,{baseUrl:e,logoLabel:o,logo:t}),jsx(a,{width:"33%",children:i&&jsx(ya,{...i})})]}),n&&jsx(a,{width:"100%",height:`${d.spacerHeight}px`})]})}function Kg({logo:e$1,baseUrl:t,logoLabel:o}){let r=g("venueColor","lightFont","darkFont");return e$1?jsx(xn,{"data-test":"logo-image",baseUrl:t,logo:e$1,logoLabel:o,height:"100%"}):jsx(n$1,{alignItems:"center",justifyContent:"center",height:"100%",children:jsx(e,{textStyle:"h1",fontSize:"xxl",color:r,children:o.toUpperCase()})})}

export { Gl as $, Zi as $a, Fs as A, yi as Aa, yt as B, Si as Ba, zs as C, ak as Ca, so as D, yk as Da, rn as E, wk as Ea, _x as F, Lk as Fa, Ys as G, Dk as Ga, an as H, qk as Ha, sb as I, Mi as Ia, cb as J, dp as Ja, sl as K, Li as Ka, fb as L, TR as La, hb as M, LR as Ma, yb as N, Ni as Na, Eb as O, Et as Oa, gl as P, m$ as Pa, ul as Q, Ai as Qa, hl as R, u$ as Ra, gn as S, S$ as Sa, Xb as T, E$ as Ta, hn as U, O$ as Ua, xn as V, X$ as Va, vt as W, J$ as Wa, Sn as X, p0 as Xa, Fl as Y, S0 as Ya, Pn as Z, _0 as Za, vn as _, J0 as _a, VT as a, wn as aa, Qi as ab, Le as b, Tt as ba, Dt as bb, _C as c, Rn as ca, uB as cb, Od as d, Ye as da, bB as db, zn as e, mS as ea, ji as eb, P as f, IS as fa, oa as fb, gi as g, $n as ga, kf as gb, dm as h, US as ha, Rf as hb, Er as i, eC as ia, $f as ib, zr as j, Wn as ja, rI as jb, gu as k, CC as ka, Gf as kb, Or as l, Hn as la, qf as lb, _r as m, zd as ma, lI as mb, Gr as n, kt as na, dI as nb, Ku as o, qd as oa, Qf as ob, ih as p, ho as pa, hI as pb, xh as q, We as qa, CI as qb, Xr as r, fP as ra, RI as rb, cs as s, hP as sa, OI as sb, Kr as t, UP as ta, Pe as tb, gs as u, mc as ua, dg as ub, de as v, hc as va, cg as vb, Jr as w, av as wa, da as wb, qh as x, Kn as xa, ma as xb, sx as y, Zn as ya, ya as yb, xx as z, jn as za, Y1 as zb };
